import React , { useEffect } from "react";
import axios from 'axios';
import { Link, useParams } from 'react-router-dom';
import {  Formik, Form, Field } from 'formik';
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { parseISO } from 'date-fns';
import classNames from "classnames";
import {CardContent, LinearProgress,Box, Fab, Modal, Fade, TextField, Backdrop, Typography, Breadcrumbs, Accordion, AccordionSummary, AccordionDetails, MenuItem} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Card from "../../components/Card/Card.jsx";
import CardHeader from "../../components/Card/CardHeader.jsx";
import CardBody from "../../components/Card/CardBody";
import GridItem from "../../components/Grid/GridItem.jsx";
import Skeleton from "@mui/material/Skeleton"
import GridContainer from "../../components/Grid/GridContainer.jsx";
import { useTheme } from "@mui/material/styles";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { mongoUrl } from '../../components/shared/mongoUrl';
import { baseUrl } from '../../components/shared/baseUrl';
import {useSelector, useDispatch} from 'react-redux';
import styles from "../../components/assets/jss/material-dashboard-react/views/dashboardStyle.js";

const datepartial = (date) =>{
            
  var st = new Date(date).toString();
  return(
      st.substring(0, 15)
  );
}

const styles1 = (theme) =>({
    cardCategoryWhite: {
      color: "rgba(255,255,255,.62)",
      margin: "0",
      fontSize: "14px",
      marginTop: "0",
      marginBottom: "0"
    },
    cardTitleWhite: {
      color: "#FFFFFF",
      marginTop: "0px",
      minHeight: "auto",
      fontWeight: "300",
      fontFamily:"'Oswald'",
      marginBottom: "3px",
      textDecoration: "none",
      textAlign:'center'
    },
    fontOswald:{
      fontFamily:"Oswald"
    },
    fontLato:{
        fontFamily:"Lato"
      },
    modal: {
      //display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      position:'absolute',
      top:'20%',
      left:'10%',
      overflowY:'scroll',
      height:'100%',
      display:'block'
    },
    modal1:{
      position: 'relative',
      maxWidth: '700px',
      margin : '0 auto',
      padding: '10px 10px 10px 10px',
      background: "rgba(0,0,0,0.5)",
      backgroundColor: 'white',
      borderRadius:'10 px',
      textAlign:'center',
      zIndex: 10
  
    }
  });

  var numberList = [
    { label: '', value: ''},{ label: 1, value: 1 },{ label: 2, value: 2}, { label: 3, value: 3},   { label: 4, value: 4},  { label: 5, value: 5}, { label: 6, value: 6},
    { label: 7, value: 7}, { label: 8, value: 8}, { label: 9, value: 9}, { label: 10, value: 10}, { label: 11, value: 11}, { label: 12, value: 12}
    , { label: 13, value: 13}, { label: 14, value: 14}, { label: 15, value: 15}, { label: 16, value: 16}, { label: 17, value: 17}, { label: 18, value: 18}
    , { label: 19, value: 19}, { label: 20, value: 20}, { label: 21, value: 21}, { label: 22, value: 22}, { label: 23, value: 23}, { label: 24, value: 24}
    , { label: 25, value: 25}, { label: 26, value: 26}, { label: 27, value: 27}, { label: 28, value: 28}, { label: 29, value: 29}
    , { label: 30, value: 30}, { label: 31, value: 31}, { label: 32, value: 32}, { label: 33, value: 33}, { label: 34, value: 34}, { label: 35, value: 35}
    , { label: 36, value: 36}, { label: 37, value: 37}, { label: 38, value: 38}, { label: 39, value: 39}, { label: 40, value: 40}
    , { label: 41, value: 41}, { label: 42, value: 42}, { label: 43, value: 43}, { label: 44, value: 44}, { label: 45, value: 45}
    , { label: 46, value: 46}, { label: 47, value: 47}, { label: 48, value: 48}, { label: 49, value: 49}, { label: 50, value: 50}
    , { label: 51, value: 51}, { label: 52, value: 52}, { label: 53, value: 53}, { label: 54, value: 54}, { label: 55, value: 55}
    , { label: 56, value: 56}, { label: 57, value: 57}, { label: 58, value: 58}, { label: 59, value: 59}, { label: 60, value: 60}
    , { label: 61, value: 61}, { label: 62, value: 62}, { label: 63, value: 63}, { label: 64, value: 64}, { label: 65, value: 65}
    , { label: 66, value: 66}, { label: 67, value: 67}, { label: 68, value: 68}, { label: 69, value: 69}, { label: 70, value: 70}
    , { label: 71, value: 71}, { label: 72, value: 72}, { label: 73, value: 73}, { label: 74, value: 54}, { label: 75, value: 75}
    , { label: 76, value: 76}, { label: 77, value: 77}, { label: 78, value: 78}, { label: 79, value: 79}, { label: 80, value: 80}
    , { label: 81, value: 81}, { label: 82, value: 82}, { label: 83, value: 83}, { label: 84, value: 84}, { label: 85, value: 85}
    , { label: 86, value: 86}, { label: 87, value: 87}, { label: 88, value: 88}, { label: 89, value: 89}, { label: 90, value: 90}
  ];
  var answerList = [
    {label: 'Strongly disagree', value: 'Strongly disagree'},
    {label: 'Disagree', value: 'Disagree'},
    {label: 'Neutral', value: 'Neutral'}, 
    {label: 'Agree', value: 'Agree'},
    {label: 'Strongly agree', value: 'Strongly agree'}
  ]

function RenderClassItem({ clas }){
  const theme = useTheme()
  const classes =styles(theme);


  return(
        <Link to={`/student/dashboard/viewsession/${clas._id}`}>
          <Card style={{backgroundColor:'#fffab4'}}>
            <CardContent>
              {clas.image.substring(0,6)!=='assets'?
              <img alt={`${clas.title}`} className="card-img-top" src={mongoUrl+clas.image} />
              :<img alt={`${clas.title}`} className="card-img-top" src={baseUrl+clas.image} />}
            </CardContent>
            <CardBody>
              <h4 style={classes.cardTitle}>{clas.title}</h4>
              <p className={classes.cardCategory}>
                {/* <span className={classes.successText}>
                  <ArrowUpward className={classes.upArrowCardCategory} /> 55%
                </span>{" "} */}
                Created: {datepartial(clas.Created)}  
                | Active: true
              </p>
            </CardBody>
            {/* <CardFooter chart>
              <div className={classes.stats}>
                <AccessTime /> viewed 4 minutes ago
              </div>
            </CardFooter> */}
          </Card>
           </Link>
        );

}

export default function StudentDashboard(props) {
  const theme = useTheme()
  const classes =styles(theme);
  const classes1 = styles1(theme)
  const [classe, setclasse] = React.useState([]);
  const [profile, setprofile] = React.useState('');
  const [loading, setloading] = React.useState(true);
  const user = useSelector(state => state.user)
  const [expanded1, setExpanded1] = React.useState('panel93');
  const [gender, setgender] = React.useState('male');
  const [implement, setimplement] = React.useState('No'); 
  const [que1, setque1] = React.useState('');
  const [que2, setque2] = React.useState('IX');
  const [que3, setque3] = React.useState('');
  const [que4, setque4] = React.useState('');
  const [que5, setque5] = React.useState('');
  const [que6, setque6] = React.useState('');
  const [que7, setque7] = React.useState('');
  const [que8, setque8] = React.useState('');
  const [que9, setque9] = React.useState('');
  const [que10, setque10] = React.useState('');
  const [que11, setque11] = React.useState('');
  const [que12, setque12] = React.useState('');
  const [que13, setque13] = React.useState('');
  const [que14, setque14] = React.useState('');
  const [que15, setque15] = React.useState('');
  const [que16, setque16] = React.useState('');
  const [que17, setque17] = React.useState('');
  const [que18, setque18] = React.useState('');
  const [que19, setque19] = React.useState('');
  const [que20, setque20] = React.useState(''); 
  const [que21, setque21] = React.useState('');   
  const [que22, setque22] = React.useState('');   
  const [que23, setque23] = React.useState('');   
  const [que24, setque24] = React.useState('');   
  const [que25, setque25] = React.useState('');   
  const [que26, setque26] = React.useState('');   
  const [que27, setque27] = React.useState('');   
  const [que28, setque28] = React.useState('');   
  const [que29, setque29] = React.useState('');   
  const [que30, setque30] = React.useState('');   
  const [que31, setque31] = React.useState('');   
  const [que32, setque32] = React.useState('');   
  const [que33, setque33] = React.useState('');   
  const [que34, setque34] = React.useState('');   
  const [que35, setque35] = React.useState('');   
  const [que36, setque36] = React.useState('');   
  const [que37, setque37] = React.useState('');   
  const [que38, setque38] = React.useState('');   
  const [que39, setque39] = React.useState('');   
  const [que40, setque40] = React.useState('');   
  const [que41, setque41] = React.useState('');
    const [que42, setque42] = React.useState('');
    const [que43, setque43] = React.useState('');
    const [que44, setque44] = React.useState('');
    const [que45, setque45] = React.useState('');
    const [que46, setque46] = React.useState('');
    const [que47, setque47] = React.useState('');
    const [que48, setque48] = React.useState('');
    const [que49, setque49] = React.useState('');
    const [que50, setque50] = React.useState('');
    const [que51, setque51] = React.useState('');   
    const [que52, setque52] = React.useState('');   
    const [que53, setque53] = React.useState('');   
    const [que54, setque54] = React.useState('');   
    const [que55, setque55] = React.useState('');   
    const [que56, setque56] = React.useState(''); 
  const [mydata, setmydata] = React.useState('');
  const [self1, setself1] = React.useState('');
  const [self2, setself2] = React.useState('');
  const [self3, setself3] = React.useState('');
  const [self4, setself4] = React.useState('');
  const [self5, setself5] = React.useState('');
  const [self6, setself6] = React.useState('');
  const [self7, setself7] = React.useState('');
  const [self8, setself8] = React.useState('');
  const [self9, setself9] = React.useState('');
  const [self10, setself10] = React.useState('');
  const [self11, setself11] = React.useState('');
  const [self12, setself12] = React.useState('');
  const [self13, setself13] = React.useState('');
  const [self14, setself14] = React.useState('');
  const [self15, setself15] = React.useState('');
  const [self16, setself16] = React.useState('');
  const [self17, setself17] = React.useState('');
  const [self18, setself18] = React.useState('');
  const [selectedDate, handleDateChange] = React.useState(new Date());
  const [error, seterror] = React.useState('');
  const [totaldata, settotaldata] = React.useState('')
  const { classId, sesId } = useParams();



  useEffect(() => {
    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();

    const loadData=()=>{
      const config = {
        headers: { Authorization: `Bearer ${user.token}` }
    };
    //console.log(user.token)
   


    axios.get(`${baseUrl}users/${user.id}`,config, { cancelToken: source.token })
    .then((response) => {
      const dat = response.data;
      var em = dat.username;
      var nam = dat.fname+' '+dat.lname
      //setemail(dat.username)
      axios.get(`${baseUrl}class`, { cancelToken: source.token })
      .then((response) => {
      const dat = Array.from(response.data)
      console.log(dat)
          
      setclasse(dat)  ////Code to set class when only  one class is created

      axios.get(`${baseUrl}pyinterpreter/profile`)
      .then((response) => {
        ///console.log(response.data)
        var countexperiment=0
          var countcontrol=0
          var impuser=false
        response.data.map((txt,index)=>{
          console.log(txt.type)
          if(txt.userName=='Rohan Kumar Jha'){
            impuser=true
          }
          if(typeof(txt.type)!='undefined' && txt.type=='experiment' && impuser==false){
            countexperiment++
          }
          if(typeof(txt.type)!='undefined' && txt.type=='control' && impuser==false){
            countcontrol++
          }
          
        })
        console.log('count of experiment '+countexperiment)
        console.log('count of control '+countcontrol)

        var newtype='experiment'
          // if(Number(countexperiment) < Number(countcontrol)){
          //   newtype='experiment'
          // }
          // if(Number(countexperiment)>Number(countcontrol)){
          //   newtype='control'
          // }
          if(impuser==true){
            newtype='experiment'
          }


        const ses = response.data.filter((session) => session.userId === user.email)
        
        if(ses.length==0){
          console.log('creating new user')
          
      
        }
        else{
          console.log('Old user')
          console.log(response.data)
          setprofile(response.data)
        }

        setloading(false)

      })
      .catch((error)=>{
        console.log(error);
        });
  
      })
      

  
      })
      .catch((error)=>{
      console.log(error);
      });
    
   
  };
    loadData();

    return() => {source.cancel();
    };
}, []);

//console.log(classe)

  const menu=classe.map((clas) => {
    return (
          <GridItem xs={12} sm={9} md={3} key={clas._id}>
                <RenderClassItem clas={clas} />
          </GridItem>
    );
})

const buttonSelect = (k,que) =>{
    var mysol='Option'+k
    console.log(k)
    console.log(que)
    console.log(que6)
    if(que==6){
        console.log('Matched')
      setque6(mysol)
    }
    else if(que==7){
        setque7(mysol)
    }
    else if(que==8){
        setque8(mysol)
    }
    else if(que==9){
        setque9(mysol)
    }
    else if(que==10){
        setque10(mysol)
    }
    else if(que==11){
        setque11(mysol)
    }
    else if(que==12){
        setque12(mysol)
    }
    else if(que==13){
        setque13(mysol)
    }
    else if(que==14){
        setque14(mysol)
    }
    else if(que==15){
        setque15(mysol)
    }
    else if(que==16){
        setque16(mysol)
    }
    else if(que==17){
        setque17(mysol)
    }
    else if(que==18){
        setque18(mysol)
    }
    else if(que==19){
        setque19(mysol)
    }
    else if(que==20){
        setque20(mysol)
    }
    else if(que==21){
        setque21(mysol)
    }
    else if(que==22){
        setque22(mysol)
    }
    else if(que==23){
        setque23(mysol)
    }
    else if(que==24){
        setque24(mysol)
    }
    else if(que==25){
        setque25(mysol)
    }
    else if(que==26){
        setque26(mysol)
    }
    else if(que==27){
        setque27(mysol)
    }
    else if(que==28){
        setque28(mysol)
    }
    else if(que==29){
        setque29(mysol)
    }
    else if(que==30){
        setque30(mysol)
    }
    else if(que==31){
        setque31(mysol)
    }
    else if(que==32){
        setque32(mysol)
    }
    else if(que==33){
        setque33(mysol)
    }
    else if(que==34){
        setque34(mysol)
    }
    else if(que==35){
        setque35(mysol)
    }
    else if(que==36){
        setque36(mysol)
    }
    else if(que==37){
        setque37(mysol)
    }

  }

  const MCQAnswers =(type, quenum, stat, option1, option2, option3, option4)=>{

    console.log(stat['que'+quenum])
     console.log(quenum) 
     if(type=='row'){   
      return (
        <GridContainer>
            <GridItem xs={12} sm={12} md={3}>
                <Link color="inherit" to="#" onClick={ (event) => event.preventDefault() }>
                                                                            
                    <Card hoverable onClick={() => buttonSelect(1,quenum)}  style={{border: "1px solid red",backgroundColor:stat['que'+quenum]=='Option1'?'#6666ff':'white'}}>
                        <b align="center"> Click to select option1 </b>
                    <CardBody>
                        <b style={classes.ana}> {option1} </b>
                    </CardBody>
                    </Card>
                </Link>
            </GridItem>
            <GridItem xs={12} sm={12} md={3}>
                <Link color="inherit" to="#" onClick={ (event) => event.preventDefault() }>
            
                    <Card hoverable onClick={() => buttonSelect(2,quenum)}  style={{border: "1px solid red",backgroundColor:stat['que'+quenum]=='Option2'?'#6666ff':'white'}}>
                        <b align="center"> Click to select option2 </b>
                    <CardBody>
                        <b style={classes.ana}> {option2} </b>
                    </CardBody>
                    </Card>
                </Link>
            </GridItem>
            <GridItem xs={12} sm={12} md={3}>
                <Link color="inherit" to="#" onClick={ (event) => event.preventDefault() }>
            
                    <Card hoverable onClick={() => buttonSelect(3,quenum)}  style={{border: "1px solid red",backgroundColor:stat['que'+quenum]=='Option3'?'#6666ff':'white'}}>
                        <b align="center"> Click to select option3 </b>
                    <CardBody>
                        <b style={classes.ana}> {option3} </b>
                    </CardBody>
                    </Card>
                </Link>
            </GridItem>
            <GridItem xs={12} sm={12} md={3}>
                <Link color="inherit" to="#" onClick={ (event) => event.preventDefault() }>
            
                    <Card hoverable onClick={() => buttonSelect(4,quenum)}  style={{border: "1px solid red",backgroundColor:stat['que'+quenum]=='Option4'?'#6666ff':'white'}}>
                        <b align="center"> Click to select option4 </b>
                    <CardBody>
                        <b style={classes.ana}> {option4} </b>
                    </CardBody>
                    </Card>
                </Link>
            </GridItem>
        </GridContainer>               
        );
      }
      else if(type=='col'){   
        return (
          <GridContainer>
              <GridItem xs={12} sm={12} md={12}>
                  <Link color="inherit" to="#" onClick={ (event) => event.preventDefault() }>
                                                                              
                      <Card hoverable onClick={() => buttonSelect(1,quenum)}  style={{border: "1px solid red",backgroundColor:stat['que'+quenum]=='Option1'?'#6666ff':'white'}}>
                          <b align="center"> Click to select option1 </b>
                      <CardBody>
                          <b style={classes.ana}> {option1} </b>
                      </CardBody>
                      </Card>
                  </Link>
              </GridItem>
              <GridItem xs={12} sm={12} md={12}>
                  <Link color="inherit" to="#" onClick={ (event) => event.preventDefault() }>
              
                      <Card hoverable onClick={() => buttonSelect(2,quenum)}  style={{border: "1px solid red",backgroundColor:stat['que'+quenum]=='Option2'?'#6666ff':'white'}}>
                          <b align="center"> Click to select option2 </b>
                      <CardBody>
                          <b style={classes.ana}> {option2} </b>
                      </CardBody>
                      </Card>
                  </Link>
              </GridItem>
              <GridItem xs={12} sm={12} md={12}>
                  <Link color="inherit" to="#" onClick={ (event) => event.preventDefault() }>
              
                      <Card hoverable onClick={() => buttonSelect(3,quenum)}  style={{border: "1px solid red",backgroundColor:stat['que'+quenum]=='Option3'?'#6666ff':'white'}}>
                          <b align="center"> Click to select option3 </b>
                      <CardBody>
                          <b style={classes.ana}> {option3} </b>
                      </CardBody>
                      </Card>
                  </Link>
              </GridItem>
              <GridItem xs={12} sm={12} md={12}>
                  <Link color="inherit" to="#" onClick={ (event) => event.preventDefault() }>
              
                      <Card hoverable onClick={() => buttonSelect(4,quenum)}  style={{border: "1px solid red",backgroundColor:stat['que'+quenum]=='Option4'?'#6666ff':'white'}}>
                          <b align="center"> Click to select option4 </b>
                      <CardBody>
                          <b style={classes.ana}> {option4} </b>
                      </CardBody>
                      </Card>
                  </Link>
              </GridItem>
          </GridContainer>               
          );
        }
        else if(type=='2x2'){   
            return (
              <GridContainer>
                  <GridItem xs={12} sm={12} md={6}>
                      <Link color="inherit" to="#" onClick={ (event) => event.preventDefault() }>
                                                                                  
                          <Card hoverable onClick={() => buttonSelect(1,quenum)}  style={{border: "1px solid red",backgroundColor:stat['que'+quenum]=='Option1'?'#6666ff':'white'}}>
                              <b align="center"> Click to select option1 </b>
                          <CardBody>
                              <b style={classes.ana}> {option1} </b>
                          </CardBody>
                          </Card>
                      </Link>
                  </GridItem>
                  <GridItem xs={12} sm={12} md={6}>
                      <Link color="inherit" to="#" onClick={ (event) => event.preventDefault() }>
                  
                          <Card hoverable onClick={() => buttonSelect(2,quenum)}  style={{border: "1px solid red",backgroundColor:stat['que'+quenum]=='Option2'?'#6666ff':'white'}}>
                              <b align="center"> Click to select option2 </b>
                          <CardBody>
                              <b style={classes.ana}> {option2} </b>
                          </CardBody>
                          </Card>
                      </Link>
                  </GridItem>
                  <GridItem xs={12} sm={12} md={6}>
                      <Link color="inherit" to="#" onClick={ (event) => event.preventDefault() }>
                  
                          <Card hoverable onClick={() => buttonSelect(3,quenum)}  style={{border: "1px solid red",backgroundColor:stat['que'+quenum]=='Option3'?'#6666ff':'white'}}>
                              <b align="center"> Click to select option3 </b>
                          <CardBody>
                              <b style={classes.ana}> {option3} </b>
                          </CardBody>
                          </Card>
                      </Link>
                  </GridItem>
                  <GridItem xs={12} sm={12} md={6}>
                      <Link color="inherit" to="#" onClick={ (event) => event.preventDefault() }>
                  
                          <Card hoverable onClick={() => buttonSelect(4,quenum)}  style={{border: "1px solid red",backgroundColor:stat['que'+quenum]=='Option4'?'#6666ff':'white'}}>
                              <b align="center"> Click to select option4 </b>
                          <CardBody>
                              <b style={classes.ana}> {option4} </b>
                          </CardBody>
                          </Card>
                      </Link>
                  </GridItem>
              </GridContainer>               
              );
            }
    }


const InputFeedback = ({ error }) =>
  error ? <div className={classNames("input-feedback")}>{error}</div> : null;

// Radio input
const RadioButton = ({
  field: { name, value, onChange, onBlur },
  id,
  label,
  className,
  ...props
}) => {
  return (
    <div>
      <input
        name={name}
        id={id}
        type="radio"
        value={id} // could be something else for output?
        checked={id === value}
        onChange={onChange}
        onBlur={onBlur}
        className={classNames("radio-button")}
        {...props}
      />
      <label htmlFor={id}>{label}</label>
    </div>
  );
};

// Radio group
const RadioButtonGroup = ({
  value,
  error,
  touched,
  id,
  label,
  className,
  children
}) => {
  const classes = classNames(
    "input-field",
    {
      "is-success": value || (!error && touched), // handle prefilled or user-filled
      "is-error": !!error && touched
    },
    className
  );

  return (
    <div className={classes}>
      <fieldset>
        <h5>{label}</h5>
        {children}
        {touched && <InputFeedback error={error} />}
      </fieldset>
    </div>
  );
};

const handleQue1Change =(event)=> {
    setque1(event.target.value)
  }
  const handleQue2Change =(event)=> {
    setque2(event.target.value)
  }
  const handleQue3Change =(event)=> {
    setque3(event.target.value)
  }
  const handleQue4Change =(event)=> {
    setque4(event.target.value)
  }
  const handleQue5Change =(event)=> {
    setque5(event.target.value)
  }
  const handleQue6Change =(event)=> {
    setque6(event.target.value)
  }
  const handleQue7Change =(event)=> {
    setque7(event.target.value)
  }
  const handleQue8Change =(event)=> {
    setque8(event.target.value)
  }
  const handleQue9Change =(event)=> {
    setque9(event.target.value)
  }
  const handleQue10Change =(event)=> {
    setque10(event.target.value)
  }
  const handleQue11Change =(event)=> {
    setque11(event.target.value)
  }
  const handleQue12Change =(event)=> {
    setque12(event.target.value)
  }
  const handleQue13Change =(event)=> {
    setque13(event.target.value)
  }
  const handleQue14Change =(event)=> {
    setque14(event.target.value)
  }
  const handleQue15Change =(event)=> {
    setque15(event.target.value)
  }
  const handleQue16Change =(event)=> {
    setque16(event.target.value)
  }
  const handleQue17Change =(event)=> {
    setque17(event.target.value)
  }
  const handleQue18Change =(event)=> {
    setque18(event.target.value)
  }
  const handleQue19Change =(event)=> {
    setque19(event.target.value)
  }
  const handleQue37Change =(event)=> {
    setque37(event.target.value)
  }
  const handleQue38Change =(event)=> {
    setque38(event.target.value)
  }
  const handleQue39Change =(event)=> {
    setque39(event.target.value)
  }  
const handleQue40Change =(event)=> {
    setque40(event.target.value)
  }
  const handleQue41Change =(event)=> {
    setque41(event.target.value)
  }
  const handleQue42Change =(event)=> {
    setque42(event.target.value)
  }
  const handleQue43Change =(event)=> {
    setque43(event.target.value)
  }
  const handleQue44Change =(event)=> {
    setque44(event.target.value)
  }
  const handleQue45Change =(event)=> {
    setque45(event.target.value)
  }
  const handleQue46Change =(event)=> {
    setque46(event.target.value)
  }
  const handleQue47Change =(event)=> {
    setque47(event.target.value)
  }
  const handleQue48Change =(event)=> {
    setque48(event.target.value)
  }
  const handleQue49Change =(event)=> {
    setque49(event.target.value)
  }
  const handleQue50Change =(event)=> {
    setque50(event.target.value)
  }
  const handleQue51Change =(event)=> {
    setque51(event.target.value)
  }
  const handleQue52Change =(event)=> {
    setque52(event.target.value)
  }
  const handleQue53Change =(event)=> {
    setque53(event.target.value)
  }
  const handleQue54Change =(event)=> {
    setque54(event.target.value)
  }
  const handleQue55Change =(event)=> {
    setque55(event.target.value)
  }
  const handleQue56Change =(event)=> {
    setque56(event.target.value)
  }
  const handleSelf1Change =(event)=> {
    setself1(event.target.value)
  }
  const handleSelf2Change =(event)=> {
    setself2(event.target.value)
  }
  const handleSelf3Change =(event)=> {
    setself3(event.target.value)
  }
  const handleSelf4Change =(event)=> {
    setself4(event.target.value)
  }
  const handleSelf5Change =(event)=> {
    setself5(event.target.value)
  }
  const handleSelf6Change =(event)=> {
    setself6(event.target.value)
  }
  const handleSelf7Change =(event)=> {
    setself7(event.target.value)
  }
  const handleSelf8Change =(event)=> {
    setself8(event.target.value)
  }
  const handleSelf9Change =(event)=> {
    setself9(event.target.value)
  }
  const handleSelf10Change =(event)=> {
    setself10(event.target.value)
  }
  const handleSelf11Change =(event)=> {
    setself11(event.target.value)
  }
  const handleSelf12Change =(event)=> {
    setself12(event.target.value)
  }
  const handleSelf13Change =(event)=> {
    setself13(event.target.value)
  }
  const handleSelf14Change =(event)=> {
    setself14(event.target.value)
  }
  const handleSelf15Change =(event)=> {
    setself15(event.target.value)
  }
  const handleSelf16Change =(event)=> {
    setself16(event.target.value)
  }
  const handleSelf17Change =(event)=> {
    setself17(event.target.value)
  }
  const handleSelf18Change =(event)=> {
    setself18(event.target.value)
  }
 
const handleAccordionChange1 = (panel) => (event, isExpanded) => {
        
    setExpanded1(isExpanded ? panel : false);
  };

  return (
    loading!==true?
      <div>  
        <div className="container">
          <div className="px-0 col-lg-8 col-md-10 col-sm-12 mx-auto text-center">
              <h1 className={classes1.fontLato}>
                  Test Questions
              </h1>
              <h4 style={classes1.fontLato}>
                    Pre-Test
              </h4>
          </div>
        </div>
     
        {loading===false? 
        <GridContainer>
                   <Formik                  
                    initialValues={{
                    gender: gender,
                    implement:implement,
                    que6:que6,
                    que7:que7,
                    que8:que8,
                    que9:que9,
                    que10:que10,
                    que11:que11,
                    que12:que12,
                    que13:que13,
                    que14:que14,
                    que15:que15,
                    que16:que16,
                    que17:que17,
                    que18:que18,
                    que19:que19,
                    que20:que20,
                    que21:que21,
                    que22:que22,
                    que23:que23,
                    que24:que24,
                    que25:que25,
                    que26:que26,
                    que27:que27,
                    que28:que28,
                    que29:que29,
                    que30:que30,
                    que31:que31,
                    que32:que32,
                    que33:que33,
                    que34:que34,
                    que35:que35,
                    que36:que36,
                    }}

                    onSubmit={(values, {setSubmitting}) => {
                      setTimeout(() => {
                      setSubmitting(false);
                      alert(JSON.stringify('Saving...', null, 2));
                                            
                      var ans = que1+','+selectedDate+','+values.gender+','+que2+','+values.implement+','+que3+','+que4+','+que5

                      console.log(ans)
                        seterror('')
                       totaldata.preTest[0].initial=ans

                        const data=
                        {
                          preTest: totaldata.preTest
                        }                     
                        console.log(data)

                      axios.put(`${baseUrl}pyinterpreter/profile/${sesId}`, data)
                      .then((response) => {
                          console.log(response.data)
                          const activity = response.data.activity1[0]
                          setmydata(activity)
                      })
                     }, 500);
                    }}
                >

       

          {({submitForm, values, isSubmitting, touched, errors}) => (
          <LocalizationProvider dateAdapter={AdapterDateFns}>
          <Form>
            <Card>
                <CardHeader color="success">
                    <h4 style={classes1.cardTitleWhite}> User Information Questionnaire</h4>
                </CardHeader>
                <CardBody>
                <GridContainer>
                <Accordion expanded={expanded1 === 'panel93'} onChange={handleAccordionChange1('panel93')}>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1bh-content"
                            id="panel1bh-header"
                            >
                            <Typography className={classes.heading}>User Information Questionnaire </Typography>
                        </AccordionSummary>
                        <AccordionDetails> 
                    <GridItem xs={12} sm={6} md={12}>
                        <Card style={{    border: '2px solid grey'}}>
                            <CardHeader color="info">
                                <h4 style={classes1.cardTitleWhite}> User Information Questionnaire</h4>
                            </CardHeader>
                            <CardBody>
                            <GridContainer>
                                <GridItem xs={12} sm={12} md={3}>
                                  <h5>1. Name:   <Field
                                                    component={TextField}
                                                    type="text"
                                                    //label="Enter name"
                                                    name="name"
                                                    value={que1}
                                                    placeholder='Enter name'
                                                    onChange={handleQue1Change} 
                                                  />
                                                  </h5> 
                                </GridItem> 
                                <GridItem xs={12} sm={12} md={3}>
                                   <h5>2. Date of Birth:  
                                    <DatePicker     
                                        label="Pick a date"
                                        value={selectedDate} 
                                        onChange={handleDateChange}
                                        renderInput={(params) => <TextField {...params} />}
 
                                      />
                                  </h5>
                                </GridItem>
                                <GridItem xs={12} sm={12} md={3}>
                                  <h5>3. Gender: </h5>
                                      <RadioButtonGroup
                                        id="gender"
                                        //label="One of these please"
                                        
                                      >
                                        <Field
                                          component={RadioButton}
                                          name="gender"
                                          id="Male"
                                          label="Male"
                                        />
                                        <Field
                                          component={RadioButton}
                                          name="gender"
                                          id="Female"
                                          label="Female"
                                        />
                                      </RadioButtonGroup>
                                </GridItem>
                                 
                                  <GridItem xs={12} sm={12} md={3}>
                                    <h5>4. Standard/Class:  
                                              <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label="Number"
                                                value={que2}
                                                onChange={handleQue2Change}
                                                select
                                                variant="standard"
                                                helperText="select"
                                                style = {{width: 60}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {[{label:'V',value:'V'},{label:'VI',value:'VI'},{label:'VII',value:'VII'},{label:'VIII',value:'VIII'},{label:'IX',value:'IX'},{label:'X',value:'X'}].map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field></h5>
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={7}>   
                                      <h5>5. Have you learned/implemented any programming problem previously?</h5>
                                    </GridItem>                                    
                                    <GridItem xs={12} sm={12} md={5}>
                                      <RadioButtonGroup
                                        id="implement"
                                        //label="One of these please"
                                        // value={values.implement}
                                        // error={errors.implement}
                                        // touched={touched.implement}
                                      >
                                        <Field
                                          component={RadioButton}
                                          name="implement"
                                          id="Yes"
                                          label="Yes"
                                        />
                                        <Field
                                          component={RadioButton}
                                          name="implement"
                                          id="No"
                                          label="No"
                                        />
                                      </RadioButtonGroup>
                                    </GridItem>

                                  <GridItem xs={12} sm={12} md={12}>
                                  <h5>6. Do you know any programming language if yes which one (Enter 'No' if you don't know)?: 
                                                <Field
                                                    component={TextField}
                                                    type="text"
                                                    //label="Enter name"
                                                    name="name"
                                                    value={que3}
                                                    placeholder='Enter name of language'
                                                    onChange={handleQue3Change}
                                                    //validate={validateSimName}
                                                    // {...this.state.edit!==true ? {disabled:true} : {disabled:false}}
                                                    //fullWidth= {true} 
                                                    />
                                  </h5>
                                  <h5>7. Last two previous mathematics exam score (percentage)?
                                                
                                                 <Field
                                                  component={TextField}
                                                  type="text"
                                                  name="score1"
                                                  //label="1st num"
                                                  value={que4}
                                                  onChange={handleQue4Change}
                                                  select
                                                  variant="standard"
                                                  helperText="score1"
                                                  //style = {{width: 60}}
                                                  margin="normal"
                                                  InputLabelProps={{
                                                      shrink: true,
                                                  }}
                                                  >
                                                  {numberList.map((option) => (
                                                      <MenuItem key={option.value} value={option.value}>
                                                      {option.label}
                                                      </MenuItem>
                                                  ))}
                                                </Field>
                                                <Field
                                                  component={TextField}
                                                  type="text"
                                                  name="std"
                                                  //label=""
                                                  value=","
                                                  //disabled={true}
                                                  //onChange={handlePatternChange}
                                                  select
                                                  variant="standard"
                                                  margin="normal"
                                                  InputLabelProps={{
                                                      shrink: true,
                                                  }}
                                                  >
                                                  {[{label:',',value:','}].map((option) => (
                                                      <MenuItem key={option.value} value={option.value}>
                                                      {option.label}
                                                      </MenuItem>
                                                  ))}
                                                </Field>
                                                <Field
                                                  component={TextField}
                                                  type="text"
                                                  name="score1"
                                                  //label="1st num"
                                                  value={que5}
                                                  onChange={handleQue5Change}
                                                  select
                                                  variant="standard"
                                                  helperText="score2"
                                                  //style = {{width: 60}}
                                                  margin="normal"
                                                  InputLabelProps={{
                                                      shrink: true,
                                                  }}
                                                  >
                                                  {numberList.map((option) => (
                                                      <MenuItem key={option.value} value={option.value}>
                                                      {option.label}
                                                      </MenuItem>
                                                  ))}
                                                </Field>
                                  </h5>
                                </GridItem>
                              </GridContainer>
                            </CardBody>
                        </Card>
                    </GridItem>
                    </AccordionDetails>
                    </Accordion>
                    
                </GridContainer>
                
                </CardBody>
            </Card>
            
            <Card>
                <CardHeader color="success">
                    <h4 style={classes1.cardTitleWhite}> Bebras Computational Thinking Test</h4>
                </CardHeader>
                <CardBody>
                <GridContainer>  
                                <b>{error!=''?'error: '+error:''}</b>    
                                <GridItem xs={12} sm={12} md={12}>
                                <Accordion expanded={expanded1 === 'panel1'} onChange={handleAccordionChange1('panel1')}>
                                        <AccordionSummary
                                            expandIcon={<ExpandMoreIcon />}
                                            aria-controls="panel1bh-content"
                                            id="panel1bh-header"
                                          >
                                            <Typography className={classes.heading}>1. Beaver tournament </Typography>
                                        </AccordionSummary>
                                      <AccordionDetails>
                                  <Card>
                                    <CardHeader color="success">
                                      <h4>1. Beaver tournament</h4>
                                    </CardHeader>
                                      
                                    <CardBody>
                                      <GridContainer>
        {/*....................................... Question1 .....................................*/}
                                        <GridItem xs={12} sm={12} md={7}>   
                                          
                                          <p> Beaver Kreso watched a tournament of races and recorded the winners of each stage on the board below.
                                            <div>
                                              The runners wore the same numbers, from 1 to 8, throughout the tournament. Kreso used numbered cards to represent each runner. 
                                            </div>
                                            When the tournament was over his younger brother Tomo mixed up all the cards, except those from all the first stage of the tournament.
                                          </p>
                                          <h5>Answer below questions following the picture on the right</h5>
                                        </GridItem>
                                        <GridItem xs={12} sm={12} md={4}>
                                          <img alt='bebimage11' width="60" height="150" className="card-img-top" src={baseUrl+'assets/images/bebimg11.PNG'} />
                                          <p>Picture of tournament with only correct cards at first stage and extra cards at right</p>
                                          <br/> 
                                        </GridItem>
                                        <GridItem xs={12} sm={12} md={12}>
                                          <h5>Q1.1. How to choose the cards of the tournament from second stage?</h5>
                                          {MCQAnswers('row', 6,{que6},'Select card randomly','Select card from the pair of cards at first stage and check if it is present in the stack at the right side.',
                                            'Select card from the pair of cards at first stage without checking if it is present in the stack at the right side',
                                            'Select card directly from stack of cards at right side without checking cards at first stage.' )}
                                       
                                        </GridItem> 
                                        <GridItem xs={12} sm={12} md={12}>
                                              <h5>Q1.2. Complete the below algorithm to select missing cards:</h5>
                                              <b>Step1: Define Current stage to second stage</b>
                                              <div><b>Step2: Select first missing card on current stage</b></div>
                                              Select among below options:
                                              {MCQAnswers('2x2', 7,{que7},
                                                <img alt='bebimage50' className="card-img-top" width="60" height="150" src={baseUrl+'assets/images/bebimg50.PNG'} />,
                                                <img alt='bebimage51' className="card-img-top" width="60" height="150" src={baseUrl+'assets/images/bebimg51.PNG'} />,
                                                <img alt='bebimage52' className="card-img-top" width="60" height="150" src={baseUrl+'assets/images/bebimg52.PNG'} />,
                                                  'None of the above' )}
                                        </GridItem>                              
                                        
                                        <GridItem xs={12} sm={12} md={12}>
                                          <h5>Q1.3. Complete the tournament by putting labels. Select one of the correct options:</h5>
                                          Select among below options:
                                          {MCQAnswers('row', 8,{que8},
                                          <img alt='bebimage12' className="card-img-top" width="60" height="150" src={baseUrl+'assets/images/bebimg12.PNG'} />
                                          ,<img alt='bebimage13' className="card-img-top" width="60" height="150" src={baseUrl+'assets/images/bebimg13.PNG'} />
                                          ,<img alt='bebimage14' className="card-img-top" width="60" height="150" src={baseUrl+'assets/images/bebimg14.PNG'} />
                                          ,<img alt='bebimage15' className="card-img-top" width="60" height="150" src={baseUrl+'assets/images/bebimg15.PNG'} />
                                          )}
                                      </GridItem>
                                      
                                      
                                    </GridContainer>
                                  </CardBody>
                                </Card> 
                                </AccordionDetails>
                              </Accordion> 
{/*............................................... Question2 .....................................*/}
                                  
                                  <Accordion expanded={expanded1 === 'panel2'} onChange={handleAccordionChange1('panel2')}>
                                        <AccordionSummary
                                            expandIcon={<ExpandMoreIcon />}
                                            aria-controls="panel1bh-content"
                                            id="panel1bh-header"
                                          >
                                            <Typography className={classes.heading}>2. Animal Competition </Typography>
                                        </AccordionSummary>
                                      <AccordionDetails>    
                                <Card>
                                  <CardHeader color="success">
                                    <h4>2. Animal competition</h4>
                                  </CardHeader>
                                  <CardBody>
                                    <GridContainer> 
                                      <GridItem xs={12} sm={12} md={6}>   
                                          <img alt='bebimage16' className="card-img-top" src={baseUrl+'assets/images/bebimg16.PNG'} />
                                          <h5>Answer the questions in the right hand side and below:</h5>
                                          <br />
                                      </GridItem>
                                      <GridItem xs={12} sm={12} md={6}>
                                        <h5>Q2.1. Observe the scores and identify the scores where the animals tied?</h5>
                                          {MCQAnswers('2x2', 9,{que9},'2,5','2,3','3,5','4' )}
                                              
                                      </GridItem>
                                      <GridItem xs={12} sm={12} md={12}>
                                          <h5>Q2.2. Analyse the tied scores and identify the score given to animal</h5>
                                          {MCQAnswers('row', 10,{que10},'2=dog,2=beaver,5=dog,5=beaver',
                                          '2=dog,2=dog,5=dog,5=beaver','2=beaver,2=dog,5=dog,5=beaver',
                                          '2=beaver,2=beaver,5=beaver,5=dog' )}
                                          <h5>Q2.3.  Observe the scores given to dogs and beavers in the competition</h5>
                                          {MCQAnswers('row', 11,{que11},'Dogs=1,3,4,5---beaver=2,6,7',
                                          'Dogs=1,2,2,3,6---beaver=4,5,7','Dogs=1,2,2,3,4,5---beaver=5,6,7',
                                          'Dogs=3,4,5---beaver=1,2,2,5,6,7' )}
                                          <h5>Q2.4. Count the dogs that took part in the competition</h5>
                                          {MCQAnswers('row', 12,{que12},'6','7','4','5' )}
                                      </GridItem>     
                                    </GridContainer>
                                  </CardBody> 
                                </Card>
                                </AccordionDetails>
                                </Accordion>                                                                           
{/*............................................... Question3 .....................................*/}
                                
                                <Accordion expanded={expanded1 === 'panel3'} onChange={handleAccordionChange1('panel3')}>
                                        <AccordionSummary
                                            expandIcon={<ExpandMoreIcon />}
                                            aria-controls="panel1bh-content"
                                            id="panel1bh-header"
                                          >
                                            <Typography className={classes.heading}>3. Beaver Code </Typography>
                                        </AccordionSummary>
                                      <AccordionDetails> 
                                <Card>
                                  <CardHeader color="success">
                                    <h4>3. Beaver Code</h4>
                                  </CardHeader>
                                  <CardBody>
                                    <GridContainer>
                                      <GridItem xs={12} sm={12} md={6}>
                                        <GridContainer>
                                          <GridItem xs={12} sm={12} md={12}>   
                                            <img alt='bebimage17' className="card-img-top" src={baseUrl+'assets/images/bebimg17.PNG'} />
                                            <h5>Identify the names of her friends Abby, Arya, Barry, Ray. 
                                              Answer the questions in the right hand side and below:</h5>
                                              <br />
                                          </GridItem>
                                          <GridItem xs={12} sm={12} md={12}>
                                           
                                              
                                          </GridItem>
                                        </GridContainer>
                                      </GridItem>
                                      <GridItem xs={12} sm={12} md={6}>
                                        <GridContainer>
                                          <GridItem xs={12} sm={12} md={12}>
                                              <h5>Q3.1. Identify the codes of first letter of four names of friend</h5>
                                              {MCQAnswers('col', 13,{que13},'ABBY(A)- two sun; ARYA(A)- two sun; BARRY(B)-flower; RAY(R)- sun, flower, sun',
                                              'ABBY(A)- two sun; ARYA(A)- two sun; BARRY(B)-flower, sun; RAY(R)- sun, flower',
                                              'ABBY(A)- two flower; ARYA(A)- two flower; BARRY(B)-sun; RAY(R)- sun, flower',
                                              'ABBY(A)- flower; ARYA(A)- flower; BARRY(B)-flower, sun; RAY(R)- flower' )}
                                            
                                          </GridItem>  
                                        </GridContainer>
                                      </GridItem>
                                      <GridItem xs={12} sm={12} md={12}>
                                      <h5>Q3.2. Observe the letter codes and identify the total code of Abby:</h5>
                                              {MCQAnswers('row', 14,{que14},
                                              <img alt='bebimage53' className="card-img-top" width="60" height="150" src={baseUrl+'assets/images/bebimg53.PNG'} />
                                              ,<img alt='bebimage54' className="card-img-top" width="60" height="150" src={baseUrl+'assets/images/bebimg54.PNG'} />
                                              ,<img alt='bebimage55' className="card-img-top" width="60" height="150" src={baseUrl+'assets/images/bebimg55.PNG'} />
                                              ,<img alt='bebimage56' className="card-img-top" width="60" height="150" src={baseUrl+'assets/images/bebimg56.PNG'} />
                                              )}
                                      <h5>Q3.3. Select the correct match of flowers with the names of Barbara’s friends: </h5>
                                            {MCQAnswers('2x2', 15, {que15},
                                            <img alt='bebimage19' className="card-img-top" width="60" height="150" src={baseUrl+'assets/images/bebimg19.PNG'} />
                                            ,<img alt='bebimage20' className="card-img-top" width="60" height="150" src={baseUrl+'assets/images/bebimg20.PNG'} />
                                            ,<img alt='bebimage21' className="card-img-top" width="60" height="150" src={baseUrl+'assets/images/bebimg21.PNG'} />
                                            ,'None of the above'
                                            )}
                                      </GridItem> 
                                    </GridContainer>
                                  </CardBody>
                                </Card>
                                </AccordionDetails>
                                </Accordion>
{/*............................................... Question4 .....................................*/}
                                
                                <Accordion expanded={expanded1 === 'panel4'} onChange={handleAccordionChange1('panel4')}>
                                        <AccordionSummary
                                            expandIcon={<ExpandMoreIcon />}
                                            aria-controls="panel1bh-content"
                                            id="panel1bh-header"
                                          >
                                            <Typography className={classes.heading}>4. Jersey Numbers </Typography>
                                        </AccordionSummary>
                                      <AccordionDetails> 
                                <Card>
                                  <CardHeader color="success">
                                    <h4>4. Jersey Numbers</h4>
                                  </CardHeader>                
                                  <CardBody>
                                    <GridContainer>
                                      <GridItem xs={12} sm={12} md={6}>   
                                          <img alt='bebimage22' className="card-img-top" src={baseUrl+'assets/images/bebimg22.PNG'} />
                                          <h5>. 
                                            Answer the questions in the right hand side:</h5>
                                            <br />
                                      </GridItem>
                                      <GridItem xs={12} sm={12} md={6}>
                                        <h5>Q4.1. Select the ordering of team2 by jersey numbers:</h5>
                                          {MCQAnswers('2x2', 16,{que16},'2,6,8,11,12,13,14,16,19,23,24,27,28,29',
                                          '2,29,28,27,24,23,19,16,14,13,12,11,8,6,3',
                                          '2,3,6,8,11,12,13,14,16,19,23,24,27,28,29',
                                          '2,3,6,8,11,23,24,27,28,29,12,13,14,16,19' )}
                                          <h5>Q4.2. How many jersey numbers are used in team 1 that area used in team 2:</h5>
                                          {MCQAnswers('row', 17,{que17},'3','2','4','1' )}
                                      </GridItem> 
                                    </GridContainer>
                                  </CardBody>
                                </Card>
                                </AccordionDetails>
                              </Accordion> 
{/*............................................... Question5 .....................................*/}
                                
                                <Accordion expanded={expanded1 === 'panel5'} onChange={handleAccordionChange1('panel5')}>
                                        <AccordionSummary
                                            expandIcon={<ExpandMoreIcon />}
                                            aria-controls="panel1bh-content"
                                            id="panel1bh-header"
                                          >
                                            <Typography className={classes.heading}>5. Passcode </Typography>
                                        </AccordionSummary>
                                      <AccordionDetails> 
                                <Card>
                                  <CardHeader color="success">
                                    <h4>5. Passcode</h4>
                                  </CardHeader>
                                  <CardBody>
                                    <GridContainer>
                                      <GridItem xs={12} sm={12} md={6}>   
                                          <h4>5. Passcode</h4>
                                          <img alt='bebimage23' className="card-img-top" src={baseUrl+'assets/images/bebimg23.PNG'} />
                                          <h5>. 
                                            Answer the questions in the right hand side and below to determine the passcode:</h5>
                                            <br />
                                            <h5>Q5.2. Select the correct passcode:</h5>
                                          {MCQAnswers('2x2', 19,{que19},'726292627','962676269','269727962','762696267' )}
                                      </GridItem>
                                      <GridItem xs={12} sm={12} md={6}>
                                          <h5>Q5.1. Select the correct option related to numbers in passcode:</h5>
                                          {MCQAnswers('col', 18,{que18},'highest value: 7, Lowest value: 2, odd digits: 9',
                                          'highest value: 9, Lowest value: 2, odd digits: 7,9'
                                          ,'highest value: 9, Lowest value: 6, odd digits: 7','None of the above' )}
                                      </GridItem>  
                                    </GridContainer>
                                  </CardBody>
                                </Card>
                              </AccordionDetails>
                            </Accordion>
{/*............................................... Question6 .....................................*/}
                                
                                <Accordion expanded={expanded1 === 'panel6'} onChange={handleAccordionChange1('panel6')}>
                                        <AccordionSummary
                                            expandIcon={<ExpandMoreIcon />}
                                            aria-controls="panel1bh-content"
                                            id="panel1bh-header"
                                          >
                                            <Typography className={classes.heading}>6. Brackets </Typography>
                                        </AccordionSummary>
                                      <AccordionDetails> 
                                <Card>
                                  <CardHeader color="success">
                                    <h4>6. Brackets</h4>
                                  </CardHeader>
                                  <CardBody>
                                    <GridContainer>
                                      <GridItem xs={12} sm={12} md={6}>   
                                          <img alt='bebimage24' className="card-img-top" src={baseUrl+'assets/images/bebimg24.PNG'} />
                                          <h5> 
                                            With the information given above, Answer the questions in the right hand side and below:</h5>
                                            <br />
                                          
                                          
                                      </GridItem>
                                      <GridItem xs={12} sm={12} md={6}>
                                          <img alt='bebimage25' className="card-img-top" src={baseUrl+'assets/images/bebimg25.PNG'} />
                                          {MCQAnswers('col', 20,{que20},
                                          <img alt='bebimage26' className="card-img-top" src={baseUrl+'assets/images/bebimg26.PNG'} />
                                          ,<img alt='bebimage27' className="card-img-top" src={baseUrl+'assets/images/bebimg27.PNG'} />
                                          ,<img alt='bebimage28' className="card-img-top" src={baseUrl+'assets/images/bebimg28.PNG'} />
                                          ,'None of the above'
                                           )}
                                          
                                      </GridItem> 
                                      <GridItem xs={12} sm={12} md={12}>
                                          <h5>Q6.2. Complete the below algorithm to identify bracket created with above method:</h5>
                                            <b>Step1: Start from the extreme left bracket and check the type</b>
                                            <div>
                                              Select among below options:
                                            </div>
                                          {MCQAnswers('2x2', 21,{que21},
                                                <img alt='bebimage57' className="card-img-top" width="60" height="150" src={baseUrl+'assets/images/bebimg57.PNG'} />,
                                                <img alt='bebimage58' className="card-img-top" width="60" height="150" src={baseUrl+'assets/images/bebimg58.PNG'} />,
                                                <img alt='bebimage59' className="card-img-top" width="60" height="150" src={baseUrl+'assets/images/bebimg59.PNG'} />,
                                                <img alt='bebimage60' className="card-img-top" width="60" height="150" src={baseUrl+'assets/images/bebimg60.PNG'} /> 
                                                  )}
                                      <h5>Q6.3. Which of the following bracelets is made with the methods descibed above:</h5>
                                          {MCQAnswers('2x2', 22,{que22},
                                          <img alt='bebimage29' className="card-img-top" src={baseUrl+'assets/images/bebimg29.PNG'} />
                                          ,<img alt='bebimage30' className="card-img-top" src={baseUrl+'assets/images/bebimg30.PNG'} />
                                          ,<img alt='bebimage31' className="card-img-top" src={baseUrl+'assets/images/bebimg31.PNG'} />
                                          ,<img alt='bebimage32' className="card-img-top" src={baseUrl+'assets/images/bebimg32.PNG'} />
                                           )}
                                      </GridItem>
                                    </GridContainer>
                                  </CardBody>
                                </Card>
                              </AccordionDetails>
                            </Accordion>
{/*............................................... Question7 .....................................*/}
                                
                                <Accordion expanded={expanded1 === 'panel7'} onChange={handleAccordionChange1('panel7')}>
                                        <AccordionSummary
                                            expandIcon={<ExpandMoreIcon />}
                                            aria-controls="panel1bh-content"
                                            id="panel1bh-header"
                                          >
                                            <Typography className={classes.heading}>7. Balls </Typography>
                                        </AccordionSummary>
                                      <AccordionDetails> 
                                <Card>
                                  <CardHeader color="success">
                                    <h4>7. Balls</h4>
                                  </CardHeader>
                                  <CardBody>
                                    <GridContainer>
                                      <GridItem xs={12} sm={12} md={6}>   
                                          <img alt='bebimage33' className="card-img-top" src={baseUrl+'assets/images/bebimg33.PNG'} />
                                          <h5> 
                                            With the information and question given above, Answer the questions in the right hand side and below to identify the final result:</h5>
                                           
                                            <br /> 
                                      </GridItem>
                                      <GridItem xs={12} sm={12} md={6}>
                                        <h5>Q7.1. Find the order of the balls in the holes A,B, and C from top to bottom:</h5>
                                          {MCQAnswers('2x2', 23,{que23},'A-1, 2, 3; B-5, 4; C-6','A-3, 2, 1; B-5, 4; C-6',
                                          'A-3, 2, 1; B-4, 5; C-6','A-1, 2, 3; B-4, 5; C-6' )} 
                                         
                                      </GridItem>
                                      <GridItem xs={12} sm={12} md={12}>

                                          <h5>Q7.2. Complete the below algorithm to identify order of balls:</h5>
                                              Select among below options:
                                              {MCQAnswers('2x2', 24,{que24},
                                                <img alt='bebimage61' className="card-img-top" width="60" height="150" src={baseUrl+'assets/images/bebimg61.PNG'} />,
                                                <img alt='bebimage62' className="card-img-top" width="60" height="150" src={baseUrl+'assets/images/bebimg62.PNG'} />,
                                                <img alt='bebimage63' className="card-img-top" width="60" height="150" src={baseUrl+'assets/images/bebimg63.PNG'} />,
                                                'None of the above' 
                                                  )}
                                          <h5>Q7.3. Select the final result after the pins A, B and C are pulled down:</h5>
                                                {MCQAnswers('2x2', 25,{que25},
                                                <img alt='bebimage34' className="card-img-top" src={baseUrl+'assets/images/bebimg34.PNG'} />
                                                ,<img alt='bebimage35' className="card-img-top" src={baseUrl+'assets/images/bebimg35.PNG'} />
                                                ,<img alt='bebimage36' className="card-img-top" src={baseUrl+'assets/images/bebimg36.PNG'} />
                                                ,<img alt='bebimage37' className="card-img-top" src={baseUrl+'assets/images/bebimg37.PNG'} />
                                                )}
                                      </GridItem> 
                                    </GridContainer>
                                  </CardBody>
                                </Card>
                                </AccordionDetails>
                                </Accordion>
{/*............................................... Question8 .....................................*/}
                                
                                <Accordion expanded={expanded1 === 'panel8'} onChange={handleAccordionChange1('panel8')}>
                                        <AccordionSummary
                                            expandIcon={<ExpandMoreIcon />}
                                            aria-controls="panel1bh-content"
                                            id="panel1bh-header"
                                          >
                                            <Typography className={classes.heading}>8. Blossom </Typography>
                                        </AccordionSummary>
                                      <AccordionDetails> 
                                <Card>
                                  <CardHeader color="success">
                                    <h4>8. Blossom</h4>
                                  </CardHeader>
                                  <CardBody>
                                    <GridContainer>
                                      <GridItem xs={12} sm={12} md={6}>   
                                          
                                          <img alt='bebimage38' className="card-img-top" src={baseUrl+'assets/images/bebimg38.PNG'} />
                                          <h5> 
                                            With the information and question given above, Answer the questions in the right hand side and below to identify the final result:</h5>
                                           
                                            <br />
                                      </GridItem>
                                      <GridItem xs={12} sm={12} md={6}>
                                          <h5>Q8.1. Identify the flower which didn’t blossom after 2 attempts of Jane (Numbering from Left):</h5>
                                          {MCQAnswers('2x2', 26,{que26},'2nd and 4th flower','1st and 3rd flower',
                                          '3rd and 5th flower','2nd flower' )}
                                          

                                          <h5>Q8.2. Follow the flowers that didn’t blossom and identify the colors left. Which colours did the computer choose for the flowers?:</h5>
                                          {MCQAnswers('2x2', 27,{que27},'blue pink blue orange orange','pink blue blue blue orange',
                                          'pink blue blue pink orange','pink pink blue pink orange' )}
                                                
                                      
                                      </GridItem> 
                                    </GridContainer>
                                  </CardBody>
                                </Card>
                                </AccordionDetails>
                              </Accordion> 
{/*............................................... Question9 .....................................*/}
                                
                                <Accordion expanded={expanded1 === 'panel9'} onChange={handleAccordionChange1('panel9')}>
                                        <AccordionSummary
                                            expandIcon={<ExpandMoreIcon />}
                                            aria-controls="panel1bh-content"
                                            id="panel1bh-header"
                                          >
                                            <Typography className={classes.heading}>9. Medical Lab </Typography>
                                        </AccordionSummary>
                                      <AccordionDetails> 
                                <Card>
                                  <CardHeader color="success">
                                  <h4>9. Medical Lab</h4>
                                  </CardHeader>
                                  <CardBody>
                                    <GridContainer>
                                      <GridItem xs={12} sm={12} md={6}>   
                                          
                                          <img alt='bebimage39' className="card-img-top" src={baseUrl+'assets/images/bebimg39.PNG'} />
                                          <h5> 
                                            With the information given above, Answer the question in the right hand side and below to identify the final result:</h5>   
                                            <br />
                                      </GridItem>
                                      <GridItem xs={12} sm={12} md={6}>
                                          <h5>Q9.1. How many times will the device shake the specimens when the program will run?</h5>
                                          {MCQAnswers('2x2', 28,{que28},'The specimens will never be shaken','The specimens will be shaken once',
                                          'The specimens will be shaken 60 times','None of the above' )}
                                      </GridItem> 
                                    </GridContainer>
                                  </CardBody>
                                </Card>
                              </AccordionDetails>
                              </Accordion>
{/*............................................... Question10 .....................................*/}
                                
                                <Accordion expanded={expanded1 === 'panel10'} onChange={handleAccordionChange1('panel10')}>
                                        <AccordionSummary
                                            expandIcon={<ExpandMoreIcon />}
                                            aria-controls="panel1bh-content"
                                            id="panel1bh-header"
                                          >
                                            <Typography className={classes.heading}>10. Secret messages </Typography>
                                        </AccordionSummary>
                                      <AccordionDetails> 
                                <Card>
                                  <CardHeader color="success">
                                    <h4>10. Secret messages</h4>
                                  </CardHeader>
                                  <CardBody>
                                    <GridContainer>
                                      <GridItem xs={12} sm={12} md={6}>   
                                          
                                          <img alt='bebimage40' className="card-img-top" src={baseUrl+'assets/images/bebimg40.PNG'} />
                                          <h5> 
                                            With the information given above, Answer the question in the right hand side:</h5>
                                            <br />
                                          <h5>Q10.2. Follow the above 4 column secret message. What message does Bertha send back?</h5>
                                          {MCQAnswers('2x2', 30,{que30},'OKWHERETOMEET!','OKIWILLBETHERE!','WILLYOUBETHERETOO!','OKIWILLMEETHIM!' )} 
                                      </GridItem>
                                      <GridItem xs={12} sm={12} md={6}>
                                        <h5>Q10.1. Select the 4 column grid of the secret message ‘OIERKLTEILH!WBEX’ that Bertha replied to Boris:</h5>
                                                {MCQAnswers('col', 29,{que29},
                                                <img alt='bebimage41' className="card-img-top" src={baseUrl+'assets/images/bebimg41.PNG'} />
                                                ,<img alt='bebimage42' className="card-img-top" src={baseUrl+'assets/images/bebimg42.PNG'} />
                                                ,<img alt='bebimage43' className="card-img-top" src={baseUrl+'assets/images/bebimg43.PNG'} />
                                                ,'None of the above'
                                                )}  
                                      </GridItem> 
                                    </GridContainer>
                                  </CardBody>
                                </Card>
                                </AccordionDetails>
                                </Accordion>
{/*............................................... Question11 .....................................*/}
                                
                                <Accordion expanded={expanded1 === 'panel11'} onChange={handleAccordionChange1('panel11')}>
                                        <AccordionSummary
                                            expandIcon={<ExpandMoreIcon />}
                                            aria-controls="panel1bh-content"
                                            id="panel1bh-header"
                                          >
                                            <Typography className={classes.heading}>11. Stack Computer </Typography>
                                        </AccordionSummary>
                                      <AccordionDetails> 
                                <Card>
                                  <CardHeader color="success">
                                    <h4>11. Stack Computer</h4>
                                  </CardHeader>
                                  <CardBody>
                                    <GridContainer>
                                      <GridItem xs={12} sm={12} md={6}>   
                                          
                                          <img alt='bebimage44' className="card-img-top" src={baseUrl+'assets/images/bebimg44.PNG'} />
                                          <h5> 
                                            With the information given above, Answer the question in the right hand side and below:</h5>
                                            <br />
                                          
                                   
                                      </GridItem>
                                      <GridItem xs={12} sm={12} md={6}>
                                            <h5>Q11.1. Identify the order in which the operations are calculated for equations 4*(8+3)-2 from left:</h5>
                                              {MCQAnswers('2x2', 31,{que31},'*,+,-','-,+,*','+,*,-','None of the above' )} 
                                            
                                            
                                      </GridItem>
                                      <GridItem xs={12} sm={12} md={12}>
                                          <h5>Q11.2. Select the computation of a*(b+c) in the stack computer:</h5>
                                              {MCQAnswers('row', 32,{que32},'abc+*','abc*+','cba+*','bca*+' )} 
                                          <h5>Q11.3. Complete the below algorithm to calculate the computation in stack computer:</h5>
                                              <b>Step1: Start from Left, find first operator (*/-/+)</b>
                                              <p>Select among below options:</p>
                                              {MCQAnswers('2x2', 33,{que33},
                                                <img alt='bebimage64' className="card-img-top" width="60" height="150" src={baseUrl+'assets/images/bebimg64.PNG'} />,
                                                <img alt='bebimage65' className="card-img-top" width="60" height="150" src={baseUrl+'assets/images/bebimg65.PNG'} />,
                                                <img alt='bebimage66' className="card-img-top" width="60" height="150" src={baseUrl+'assets/images/bebimg66.PNG'} />,
                                                'None of the above' 
                                              )}
                                          <h5>Q11.4. How should the following computation-4*(8+3)-2 be entered:</h5>
                                              {MCQAnswers('row', 34,{que34},'483+-2*','483+2*-','483+*2-','48+3*2-' )} 
                                      </GridItem> 
                                    </GridContainer>
                                  </CardBody>
                                </Card>
                                </AccordionDetails>
                                </Accordion>
{/*............................................... Question12 .....................................*/}
                                
                                <Accordion expanded={expanded1 === 'panel12'} onChange={handleAccordionChange1('panel12')}>
                                        <AccordionSummary
                                            expandIcon={<ExpandMoreIcon />}
                                            aria-controls="panel1bh-content"
                                            id="panel1bh-header"
                                          >
                                            <Typography className={classes.heading}>12. Throw the Dice </Typography>
                                        </AccordionSummary>
                                      <AccordionDetails> 
                                <Card>
                                  <CardHeader color="success">
                                    <h4>12. Throw the Dice</h4>
                                  </CardHeader>
                                  <CardBody>
                                    <GridContainer>
                                      <GridItem xs={12} sm={12} md={6}>      
                                          <img alt='bebimage45' className="card-img-top" src={baseUrl+'assets/images/bebimg45.PNG'} />
                                          <h5> 
                                            With the information given above, Answer the question in the right hand side:</h5>
                                      </GridItem>
                                      <GridItem xs={12} sm={12} md={6}>
                                      <h5>Q12.1. Analyse the above algorithm and select the options concerning three throws that will send the young beavers to the sports field:</h5>
                                                {MCQAnswers('2x2', 35,{que35},'First throw less than second throw, Third throw less than first throw"',
                                                'First throw greater than second throw, Third throw less than first throw',
                                                'First throw less than equal to second throw, Third throw greater than equal to first throw',
                                                'First throw greater than second throw, Third throw greater than first throw' )}
                                            
                                      </GridItem> 
                                      <GridItem xs={12} sm={12} md={12}>
                                      <h5>Q12.2. Which sequence of throws will send the young beavers to the sports field?</h5>
                                                {MCQAnswers('2x2', 36,{que36},
                                                <img alt='bebimage46' className="card-img-top" src={baseUrl+'assets/images/bebimg46.PNG'} />
                                                ,<img alt='bebimage47' className="card-img-top" src={baseUrl+'assets/images/bebimg47.PNG'} />
                                                ,<img alt='bebimage48' className="card-img-top" src={baseUrl+'assets/images/bebimg48.PNG'} />
                                                ,<img alt='bebimage49' className="card-img-top" src={baseUrl+'assets/images/bebimg49.PNG'} />
                                                )}
                                      </GridItem>
                                    </GridContainer>
                                  </CardBody>
                                </Card>
                                </AccordionDetails>
                                </Accordion>
                                <b>{error!=''?'error: '+error:''}</b>
                                </GridItem>
                              </GridContainer>
                </CardBody>
            </Card>
            <Card>
                <CardHeader color="success">
                    <h4 style={classes1.cardTitleWhite}> Self-efficacy test</h4>
                </CardHeader>
                <CardBody>
                <GridContainer>
                <Accordion expanded={expanded1 === 'panel92'} onChange={handleAccordionChange1('panel92')}>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1bh-content"
                            id="panel1bh-header"
                            >
                            <Typography className={classes.heading}>Self-efficacy test </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                    <GridItem xs={12} sm={6} md={12}>
                        <Card style={{    border: '2px solid grey'}}>
                            <CardHeader color="info">
                                <h4 style={classes1.cardTitleWhite}>Self-efficacy test </h4>
                            </CardHeader>
                            <CardBody>
                                <GridContainer>
                                <GridItem xs={12} sm={12} md={8}>   
                                            <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label=""
                                                value="1. I distinguish repeating structures within data or images."
                                                //disabled={true}
                                                //onChange={handlePatternChange}
                                                select
                                                variant="standard"
                                                //helperText="select"
                                                //style = {{width: 30}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {[{label:'1. I distinguish repeating structures within data or images.',value:'1. I distinguish repeating structures within data or images.'}].map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                            </Field>
                                    </GridItem>                                    
                                    <GridItem xs={12} sm={12} md={4}>
                                            <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label="Number"
                                                value={self1}
                                                onChange={handleSelf1Change}
                                                select
                                                variant="standard"
                                                helperText="select"
                                                //style = {{width: 60}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {answerList.map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field>
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={8}>   
                                          <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label=""
                                                value="2. I evaluate the steps necessary to solve the problem from different angles. "
                                                //disabled={true}
                                                //onChange={handlePatternChange}
                                                select
                                                variant="standard"
                                                //helperText="select"
                                                //style = {{width: 30}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {[{label:'2. I evaluate the steps necessary to solve the problem from different angles. ',value:'2. I evaluate the steps necessary to solve the problem from different angles. '}].map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                            </Field>
                                    </GridItem>                                    
                                    <GridItem xs={12} sm={12} md={4}>
                                            <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label="Number"
                                                value={self2}
                                                onChange={handleSelf2Change}
                                                select
                                                variant="standard"
                                                helperText="select"
                                                //style = {{width: 60}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {answerList.map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field>
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={8}>   
                                            <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label=""
                                                value="3. I run multiple tasks at the same time to solve the problem. "
                                                //disabled={true}
                                                //onChange={handlePatternChange}
                                                select
                                                variant="standard"
                                                //helperText="select"
                                                //style = {{width: 30}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {[{label:'3. I run multiple tasks at the same time to solve the problem. ',value:'3. I run multiple tasks at the same time to solve the problem. '}].map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                            </Field>
                                    </GridItem>                                    
                                    <GridItem xs={12} sm={12} md={4}>
                                            <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label="Number"
                                                value={self3}
                                                onChange={handleSelf3Change}
                                                select
                                                variant="standard"
                                                helperText="select"
                                                //style = {{width: 60}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {answerList.map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field>
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={8}>   
                                            <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label=""
                                                value="4. I can distinguish if a problem I have encountered is similar to the problems I have encountered before. "
                                                //disabled={true}
                                                //onChange={handlePatternChange}
                                                select
                                                variant="standard"
                                                //helperText="select"
                                                //style = {{width: 30}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {[{label:'4. I can distinguish if a problem I have encountered is similar to the problems I have encountered before. ',value:'4. I can distinguish if a problem I have encountered is similar to the problems I have encountered before. '}].map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                            </Field>
                                    </GridItem>                                    
                                    <GridItem xs={12} sm={12} md={4}>
                                            <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label="Number"
                                                value={self4}
                                                onChange={handleSelf4Change}
                                                select
                                                variant="standard"
                                                helperText="select"
                                                //style = {{width: 60}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {answerList.map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field>
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={8}>   
                                            <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label=""
                                                value="5. I examine the data I have collected to solve the problem. "
                                                //disabled={true}
                                                //onChange={handlePatternChange}
                                                select
                                                variant="standard"
                                                //helperText="select"
                                                //style = {{width: 30}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {[{label:'5. I examine the data I have collected to solve the problem. ',value:'5. I examine the data I have collected to solve the problem. '}].map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                            </Field>
                                    </GridItem>                                    
                                    <GridItem xs={12} sm={12} md={4}>
                                            <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label="Number"
                                                value={self5}
                                                onChange={handleSelf5Change}
                                                select
                                                variant="standard"
                                                helperText="select"
                                                //style = {{width: 60}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {answerList.map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field>
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={8}>   
                                            <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label=""
                                                value="6. I relate problems to real life. "
                                                //disabled={true}
                                                //onChange={handlePatternChange}
                                                select
                                                variant="standard"
                                                //helperText="select"
                                                //style = {{width: 30}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {[{label:'6. I relate problems to real life. ',value:'6. I relate problems to real life. '}].map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                            </Field>
                                    </GridItem>                                    
                                    <GridItem xs={12} sm={12} md={4}>
                                            <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label="Number"
                                                value={self6}
                                                onChange={handleSelf6Change}
                                                select
                                                variant="standard"
                                                helperText="select"
                                                //style = {{width: 60}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {answerList.map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field>
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={8}>   
                                            <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label=""
                                                value="7. I separate the data by type (text, number, series, etc.). "
                                                //disabled={true}
                                                //onChange={handlePatternChange}
                                                select
                                                variant="standard"
                                                //helperText="select"
                                                //style = {{width: 30}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {[{label:'7. I separate the data by type (text, number, series, etc.). ',value:'7. I separate the data by type (text, number, series, etc.). '}].map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                            </Field>
                                    </GridItem>                                    
                                    <GridItem xs={12} sm={12} md={4}>
                                            <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label="Number"
                                                value={self7}
                                                onChange={handleSelf7Change}
                                                select
                                                variant="standard"
                                                helperText="select"
                                                //style = {{width: 60}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {answerList.map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field>
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={8}>   
                                            <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label=""
                                                value="8. I understand whether the problem is composed of sub-problems. "
                                                //disabled={true}
                                                //onChange={handlePatternChange}
                                                select
                                                variant="standard"
                                                //helperText="select"
                                                //style = {{width: 30}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {[{label:'8. I understand whether the problem is composed of sub-problems. ',value:'8. I understand whether the problem is composed of sub-problems. '}].map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                            </Field>
                                    </GridItem>                                    
                                    <GridItem xs={12} sm={12} md={4}>
                                            <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label="Number"
                                                value={self8}
                                                onChange={handleSelf8Change}
                                                select
                                                variant="standard"
                                                helperText="select"
                                                //style = {{width: 60}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {answerList.map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field>
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={8}>   
                                            <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label=""
                                                value="9. I decide whether the data to be used to solve the problem is sufficient or not. "
                                                //disabled={true}
                                                //onChange={handlePatternChange}
                                                select
                                                variant="standard"
                                                //helperText="select"
                                                //style = {{width: 30}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {[{label:'9. I decide whether the data to be used to solve the problem is sufficient or not. ',value:'9. I decide whether the data to be used to solve the problem is sufficient or not. '}].map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                            </Field>
                                    </GridItem>                                    
                                    <GridItem xs={12} sm={12} md={4}>
                                            <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label="Number"
                                                value={self9}
                                                onChange={handleSelf9Change}
                                                select
                                                variant="standard"
                                                helperText="select"
                                                //style = {{width: 60}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {answerList.map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field>
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={8}>   
                                            <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label=""
                                                value="10. I comment on the data I used to solve the problem. "
                                                //disabled={true}
                                                //onChange={handlePatternChange}
                                                select
                                                variant="standard"
                                                //helperText="select"
                                                //style = {{width: 30}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {[{label:'10. I comment on the data I used to solve the problem. ',value:'10. I comment on the data I used to solve the problem. '}].map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                            </Field>
                                    </GridItem>                                    
                                    <GridItem xs={12} sm={12} md={4}>
                                            <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label="Number"
                                                value={self10}
                                                onChange={handleSelf10Change}
                                                select
                                                variant="standard"
                                                helperText="select"
                                                //style = {{width: 60}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {answerList.map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field>
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={8}>   
                                            <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label=""
                                                value="11. I connect the problem I have encountered with the problems I have encountered before. "
                                                //disabled={true}
                                                //onChange={handlePatternChange}
                                                select
                                                variant="standard"
                                                //helperText="select"
                                                //style = {{width: 30}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {[{label:'11. I connect the problem I have encountered with the problems I have encountered before. ',value:'11. I connect the problem I have encountered with the problems I have encountered before. '}].map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                            </Field>
                                    </GridItem>                                    
                                    <GridItem xs={12} sm={12} md={4}>
                                            <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label="Number"
                                                value={self11}
                                                onChange={handleSelf11Change}
                                                select
                                                variant="standard"
                                                helperText="select"
                                                //style = {{width: 60}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {answerList.map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field>
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={8}>   
                                            <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label=""
                                                value="12. If the problem has sub-problems, I manage the solution processes of these sub-problems. "
                                                //disabled={true}
                                                //onChange={handlePatternChange}
                                                select
                                                variant="standard"
                                                //helperText="select"
                                                //style = {{width: 30}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {[{label:'12. If the problem has sub-problems, I manage the solution processes of these sub-problems. ',value:'12. If the problem has sub-problems, I manage the solution processes of these sub-problems. '}].map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                            </Field>
                                    </GridItem>                                    
                                    <GridItem xs={12} sm={12} md={4}>
                                            <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label="Number"
                                                value={self12}
                                                onChange={handleSelf12Change}
                                                select
                                                variant="standard"
                                                helperText="select"
                                                //style = {{width: 60}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {answerList.map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field>
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={8}>   
                                            <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label=""
                                                value="13. I find the fastest solution that works correctly through different process steps. "
                                                //disabled={true}
                                                //onChange={handlePatternChange}
                                                select
                                                variant="standard"
                                                //helperText="select"
                                                //style = {{width: 30}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {[{label:'13. I find the fastest solution that works correctly through different process steps. ',value:'13. I find the fastest solution that works correctly through different process steps. '}].map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                            </Field>
                                    </GridItem>                                    
                                    <GridItem xs={12} sm={12} md={4}>
                                            <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label="Number"
                                                value={self13}
                                                onChange={handleSelf13Change}
                                                select
                                                variant="standard"
                                                helperText="select"
                                                //style = {{width: 60}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {answerList.map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field>
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={8}>   
                                            <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label=""
                                                value="14. I can understand how a problem I have encountered differs from the problems I have encountered before. "
                                                //disabled={true}
                                                //onChange={handlePatternChange}
                                                select
                                                variant="standard"
                                                //helperText="select"
                                                //style = {{width: 30}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {[{label:'14. I can understand how a problem I have encountered differs from the problems I have encountered before. ',value:'14. I can understand how a problem I have encountered differs from the problems I have encountered before. '}].map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                            </Field>
                                    </GridItem>                                    
                                    <GridItem xs={12} sm={12} md={4}>
                                            <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label="Number"
                                                value={self14}
                                                onChange={handleSelf14Change}
                                                select
                                                variant="standard"
                                                helperText="select"
                                                //style = {{width: 60}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {answerList.map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field>
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={8}>   
                                            <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label=""
                                                value="15. I organize the data I collect in a way that is more understandable for the solution of the problem."
                                                //disabled={true}
                                                //onChange={handlePatternChange}
                                                select
                                                variant="standard"
                                                //helperText="select"
                                                //style = {{width: 30}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {[{label:'15. I organize the data I collect in a way that is more understandable for the solution of the problem.',value:'15. I organize the data I collect in a way that is more understandable for the solution of the problem.'}].map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                            </Field>
                                            
                                    </GridItem>                                    
                                    <GridItem xs={12} sm={12} md={4}>
                                            <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label="Number"
                                                value={self15}
                                                onChange={handleSelf15Change}
                                                select
                                                variant="standard"
                                                helperText="select"
                                                //style = {{width: 60}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {answerList.map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field>
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={8}>   
                                            <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label=""
                                                value="16. I decide whether the problem solution I chose is fit for purpose. "
                                                //disabled={true}
                                                //onChange={handlePatternChange}
                                                select
                                                variant="standard"
                                                //helperText="select"
                                                //style = {{width: 30}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {[{label:'16. I decide whether the problem solution I chose is fit for purpose. ',value:'16. I decide whether the problem solution I chose is fit for purpose. '}].map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                            </Field>
                                    </GridItem>                                    
                                    <GridItem xs={12} sm={12} md={4}>
                                            <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label="Number"
                                                value={self16}
                                                onChange={handleSelf16Change}
                                                select
                                                variant="standard"
                                                helperText="select"
                                                //style = {{width: 60}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {answerList.map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field>
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={8}>   
                                            <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label=""
                                                value="17. If the problem has sub-problems, I divide it into smaller sub-problems."
                                                //disabled={true}
                                                //onChange={handlePatternChange}
                                                select
                                                variant="standard"
                                                //helperText="select"
                                                //style = {{width: 30}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {[{label:'17. If the problem has sub-problems, I divide it into smaller sub-problems.',value:'17. If the problem has sub-problems, I divide it into smaller sub-problems.'}].map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                            </Field>
                                    </GridItem>                                    
                                    <GridItem xs={12} sm={12} md={4}>
                                            <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label="Number"
                                                value={self17}
                                                onChange={handleSelf17Change}
                                                select
                                                variant="standard"
                                                helperText="select"
                                                //style = {{width: 60}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {answerList.map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field>
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={8}>   
                                            <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label=""
                                                value="18. I develop different solution proposals for the solution of a problem."
                                                //disabled={true}
                                                //onChange={handlePatternChange}
                                                select
                                                variant="standard"
                                                //helperText="select"
                                                //style = {{width: 30}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {[{label:'18. I develop different solution proposals for the solution of a problem.',value:'18. I develop different solution proposals for the solution of a problem.'}].map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                            </Field>
                                    </GridItem>                                    
                                    <GridItem xs={12} sm={12} md={4}>
                                            <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label="Number"
                                                value={self18}
                                                onChange={handleSelf18Change}
                                                select
                                                variant="standard"
                                                helperText="select"
                                                //style = {{width: 60}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {answerList.map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field>
                                    </GridItem>
                                </GridContainer>
                            </CardBody>
                        </Card>
                    </GridItem>
                    </AccordionDetails>
                    </Accordion>
            
                </GridContainer>
                
                </CardBody>
            </Card>
            <div className="container">
          <div className="px-0 col-lg-8 col-md-10 col-sm-12 mx-auto text-center">
              <h4 style={classes1.fontLato}>
                    Post-Test
              </h4>
          </div>
        </div>
        
            
            <Card>
                <CardHeader color="success">
                    <h4 style={classes1.cardTitleWhite}> Bebras Computational Thinking Test</h4>
                </CardHeader>
                <CardBody>
                <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                              <Accordion expanded={expanded1 === 'panel21'} onChange={handleAccordionChange1('panel21')}>
                                      <AccordionSummary
                                          expandIcon={<ExpandMoreIcon />}
                                          aria-controls="panel1bh-content"
                                          id="panel1bh-header"
                                        >
                                          <Typography className={classes.heading}>1. Select a Picture </Typography>
                                      </AccordionSummary>
                                    <AccordionDetails>
                                <Card>
                                  <CardHeader color="success">
                                    <h4>1. Select a Picture</h4>
                                  </CardHeader>                                    
                                  <CardBody>
                                  <GridContainer> 
      {/*....................................... Question1 .....................................*/}
                                      <GridItem xs={12} sm={12} md={6}>   
                                          <p>Johnny has 8 photos. He wants to give one to Bella.</p>
                                          <p>He asks Bella three questions to help him select the best picture.</p>
                                          <p><b>Johnny's Question</b>.................................................................<b>Bella's Answer</b></p>
                                          <p>1. Do you want a photo with a beach umbrella? ............................<span><b>Yes</b></span></p>
                                          <p>2. Do you want a photo where I wear something on my head?<span><b>......No</b></span></p>
                                          <p>3. Do you want a photo where you can see the sea?.................<span><b>Yes</b></span></p>
                                        
                                        <p> Answer the below questions to select photo for Bella.</p>
                                          
                                      </GridItem>
                                      <GridItem xs={12} sm={12} md={4}>
                                            <img alt='bebimage68' width="60" height="150" className="card-img-top" src={baseUrl+'assets/images/bebimg68.PNG'} />
                                        
                                      </GridItem>
                                      <GridItem xs={12} sm={12} md={8}>
                                        <h5>Q1.1. Select the correct options with objects and correct name in photo: </h5>
                                        {MCQAnswers('2x2', 6,{que6},
                                        <img alt='bebimage69' className="card-img-top" width="60" height="150" src={baseUrl+'assets/images/bebimg69.PNG'} />
                                        ,<img alt='bebimage70' className="card-img-top" width="60" height="150" src={baseUrl+'assets/images/bebimg70.PNG'} />
                                        ,<img alt='bebimage71' className="card-img-top" width="60" height="150" src={baseUrl+'assets/images/bebimg71.PNG'} />
                                        ,<img alt='bebimage72' className="card-img-top" width="60" height="150" src={baseUrl+'assets/images/bebimg72.PNG'} />
                                        )}
                                     
                                      </GridItem> 
                                      <GridItem xs={12} sm={12} md={8}>
                                            <h5>Q1.2. Select the correct photo for bella based on the above questions:</h5>
                                            Select among below options:
                                            {MCQAnswers('2x2', 7,{que7},
                                              <img alt='bebimage73' className="card-img-top" width="60" height="150" src={baseUrl+'assets/images/bebimg73.PNG'} />,
                                              <img alt='bebimage74' className="card-img-top" width="60" height="150" src={baseUrl+'assets/images/bebimg74.PNG'} />,
                                              <img alt='bebimage75' className="card-img-top" width="60" height="150" src={baseUrl+'assets/images/bebimg75.PNG'} />,
                                              <img alt='bebimage76' className="card-img-top" width="60" height="150" src={baseUrl+'assets/images/bebimg76.PNG'} />
                                                )}
                                      </GridItem> 
                                      </GridContainer>
                                      </CardBody>  
                                    </Card>                           
                                  </AccordionDetails>
                                </Accordion>
{/*............................................... Question2 .....................................*/}
                                
            <Accordion expanded={expanded1 === 'panel22'} onChange={handleAccordionChange1('panel22')}>
                                      <AccordionSummary
                                          expandIcon={<ExpandMoreIcon />}
                                          aria-controls="panel1bh-content"
                                          id="panel1bh-header"
                                        >
                                          <Typography className={classes.heading}>2. Tube System </Typography>
                                      </AccordionSummary>
                                    <AccordionDetails>    
                              <Card>
                                <CardHeader color="success">
                                  <h4>2. Tube System</h4>
                                </CardHeader>
                                <CardBody>
                                  <GridContainer> 
                                    <GridItem xs={12} sm={12} md={6}>   
                                        <img alt='bebimage77' className="card-img-top" src={baseUrl+'assets/images/bebimg77.PNG'} />
                                        <h5>Answer the questions in the right hand side:</h5>
                                        <br />
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={6}>
                                        <h5>2.1. In which tube should the mouse start so that it reaches the cheese?</h5>
                                        Select among below options:
                                        {MCQAnswers('row', 8,{que8},2,3,4,5)}
                                      </GridItem>
                                         
                                  </GridContainer>
                                </CardBody> 
                              </Card>
                              </AccordionDetails>
                              </Accordion>                                                                           
{/*............................................... Question3 .....................................*/}
                              
                              <Accordion expanded={expanded1 === 'panel23'} onChange={handleAccordionChange1('panel23')}>
                                      <AccordionSummary
                                          expandIcon={<ExpandMoreIcon />}
                                          aria-controls="panel1bh-content"
                                          id="panel1bh-header"
                                        >
                                          <Typography className={classes.heading}>3. News editing </Typography>
                                      </AccordionSummary>
                                    <AccordionDetails> 
                              <Card>
                                <CardHeader color="success">
                                  <h4>3. News editing</h4>
                                </CardHeader>
                                <CardBody>
                                  <GridContainer>
                                    <GridItem xs={12} sm={12} md={6}>
                                      <GridContainer>
                                        <GridItem xs={12} sm={12} md={12}>   
                                          <img alt='bebimage78' className="card-img-top" src={baseUrl+'assets/images/bebimg78.PNG'} />
                                          <h5>Answer the questions in the right hand side and below:</h5>
                                            <br />
                                        </GridItem>
                                        
                                      </GridContainer>
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={6}>
                                      <GridContainer>
                                          <GridItem xs={12} sm={12} md={12}>
                                              <h5>Q3.1. Count the students working around 12:00? Observe the red cells</h5>
                                              {MCQAnswers('row', 9,{que9},'3','5','2','4' )}
                                              
                                          </GridItem>
                                          <GridItem xs={12} sm={12} md={12}>
                                              <h5>3.2. Select the time at which maximum students are working on the computer?</h5>
                                              {MCQAnswers('row', 10,{que10},'8:00','9:00',
                                              '11:00','13:00' )}
                                              
                                          </GridItem>
                                        
                                      
                                        
                                      </GridContainer>
                                    </GridItem> 
                                    <GridItem xs={12} sm={12} md={12}>       
                                      <h5>Q3.3. What is the minimum number of computers needed for all of the students to work according to the plan shown above?</h5>
                                      {MCQAnswers('row', 11,{que11},'4','5','6','7' )}
                                              
                                          </GridItem>
                                  </GridContainer>
                                </CardBody>
                              </Card>
                              </AccordionDetails>
                              </Accordion>
{/*............................................... Question4 .....................................*/}
                              
                              <Accordion expanded={expanded1 === 'panel24'} onChange={handleAccordionChange1('panel24')}>
                                      <AccordionSummary
                                          expandIcon={<ExpandMoreIcon />}
                                          aria-controls="panel1bh-content"
                                          id="panel1bh-header"
                                        >
                                          <Typography className={classes.heading}>4. Five sticks </Typography>
                                      </AccordionSummary>
                                    <AccordionDetails> 
                              <Card>
                                <CardHeader color="success">
                                  <h4>4. Five sticks</h4>
                                </CardHeader>                
                                <CardBody>
                                  <GridContainer>
                                      
                                      <GridItem xs={12} sm={12} md={6}>   
                                        <img alt='bebimage79' className="card-img-top" src={baseUrl+'assets/images/bebimg79.PNG'} />
                                        <h5>. 
                                          Based on the above information, Answer the questions below:</h5>
                                          <br />
                                      </GridItem>
                                      <GridItem xs={12} sm={12} md={6}>   
                                      </GridItem>

                                     
                                      <GridItem xs={12} sm={12} md={6}>
                                          <h5>Q4.1. Which stick did Nola changed from Adam’s shape? Select the correct one </h5>
                                          {MCQAnswers('row', 12,{que12},
                                            <img alt='bebimage80' className="card-img-top" width="60" height="150" src={baseUrl+'assets/images/bebimg80.PNG'} />
                                            ,<img alt='bebimage81' className="card-img-top" width="60" height="150" src={baseUrl+'assets/images/bebimg81.PNG'} />
                                            ,<img alt='bebimage82' className="card-img-top" width="60" height="150" src={baseUrl+'assets/images/bebimg82.PNG'} />
                                            ,'None of the above'
                                            )}
                                      </GridItem>
                                      <GridItem xs={12} sm={12} md={6}>   
                                      </GridItem>

                                     
                                      <GridItem xs={12} sm={12} md={6}>
                                          <GridContainer>
                                              <GridItem xs={12} sm={12} md={8}>
                                                  <h5>Q4.2. If Bob wants to make the shape on the right,which stick should be changed from Nola's shape? Select the correct option</h5>      
                                              </GridItem>
                                              <GridItem xs={12} sm={12} md={4}>
                                                  <img alt='bebimage83' className="card-img-top" width="60" height="150" src={baseUrl+'assets/images/bebimg83.PNG'} />
                                              </GridItem>
                                          </GridContainer>
                                          
                                            {MCQAnswers('row', 13,{que13},
                                            <img alt='bebimage84' className="card-img-top" width="60" height="150" src={baseUrl+'assets/images/bebimg84.PNG'} />
                                            ,<img alt='bebimage85' className="card-img-top" width="60" height="150" src={baseUrl+'assets/images/bebimg85.PNG'} />
                                            ,<img alt='bebimage86' className="card-img-top" width="60" height="150" src={baseUrl+'assets/images/bebimg86.PNG'} />
                                            ,'None of the above'
                                            )}
                                          
                                        </GridItem>
                                       
                                     
                                      <GridItem xs={12} sm={12} md={6}>   
                                      </GridItem>
                                        <GridItem xs={12} sm={12} md={6}>
                                          <h5>Q4.3. Select the shape Bob won't be able to make:</h5>
                                            {MCQAnswers('row', 14,{que14},
                                            <img alt='bebimage87' className="card-img-top" width="60" height="150" src={baseUrl+'assets/images/bebimg87.PNG'} />
                                            ,<img alt='bebimage88' className="card-img-top" width="60" height="150" src={baseUrl+'assets/images/bebimg88.PNG'} />
                                            ,<img alt='bebimage89' className="card-img-top" width="60" height="150" src={baseUrl+'assets/images/bebimg89.PNG'} />
                                            ,<img alt='bebimage90' className="card-img-top" width="60" height="150" src={baseUrl+'assets/images/bebimg90.PNG'} />
                                            )}
                                        </GridItem>
                                        
                                        
                                    
                                  </GridContainer>
                                </CardBody>
                              </Card>
                              </AccordionDetails>
                            </Accordion> 
{/*............................................... Question5 .....................................*/}
                              
                              <Accordion expanded={expanded1 === 'panel25'} onChange={handleAccordionChange1('panel25')}>
                                      <AccordionSummary
                                          expandIcon={<ExpandMoreIcon />}
                                          aria-controls="panel1bh-content"
                                          id="panel1bh-header"
                                        >
                                          <Typography className={classes.heading}>5. One too many </Typography>
                                      </AccordionSummary>
                                    <AccordionDetails> 
                              <Card>
                                <CardHeader color="success">
                                  <h4>5. Passcode</h4>
                                </CardHeader>
                                <CardBody>
                                  <GridContainer>
                                    <GridItem xs={12} sm={12} md={6}>   
                                        <h4>5. One too many</h4>
                                        <p>I recently discovered a silly mistake I made in a long piece of alphanumeric text.</p>
                                          All 1's should be 11's and all 11's should be 1's. Luckily, I can be rather smart and I have an
                                          editor which enables me to replace a sequence of characters with another sequence.
                                        <p>See what happops in a soptopce in which I replace all occuropces (except the last one)
                                        of en with op!</p>
                                        Of, wofse, feplacing all occuffences of r (except the last one) with f.
                                        <h5> 
                                          Answer the questions in the right hand side and help me to fix my text:</h5>
                                          <br />
                                          
                                        
                                        
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={6}>
                                      <h5>Q5.1. Select the new text when you replace ‘1’ by 11 and ‘11’ by 1 in 81911541161?</h5>
                                      {MCQAnswers('2x2', 15,{que15},'81191541161','81915411611','81191541611','None of the above' )}
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={12}>
                                        <h5>Q5.2. Can you identify the original text when en is replaced by op in ‘See what happops in a soptopce in which I replace all occuropces’?</h5>
                                        {MCQAnswers('row', 16,{que16},'See what happens in a soptence in which I replace all occurences',
                                        'See what happens in a sentence in which I replace all occurences',
                                        'See what happens in a sentence in which I replace all occurces',
                                        'None of the  above' )}  
                                   
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={12}>
                                      <h5>Q5.3. In my text above there was a mistake where All 1’s should be 11’s and all 11’s should be 1’s. I have an editor which can replace a sequence of character with another sequence. 
                                          What should I do to fix the text?:</h5>
                                        {MCQAnswers('row', 17,{que17},'Replace all 11’s with 1’s and all 1’s with 11’s',
                                        'Replace all 1’s with 11’s and all 11’s with 1’s',
                                        'Replace all 1’s with $s and all $s with 11’s and then all 11’s with 1’s',
                                        'Replace all 11’s with $s and all 1’ with 11’s and then all $s with 1’s' )} 
                                      </GridItem>  
                                  </GridContainer>
                                </CardBody>
                              </Card>
                            </AccordionDetails>
                          </Accordion>
{/*............................................... Question6 .....................................*/}
                              
                              <Accordion expanded={expanded1 === 'panel26'} onChange={handleAccordionChange1('panel26')}>
                                      <AccordionSummary
                                          expandIcon={<ExpandMoreIcon />}
                                          aria-controls="panel1bh-content"
                                          id="panel1bh-header"
                                        >
                                          <Typography className={classes.heading}>6. Loading Lisas </Typography>
                                      </AccordionSummary>
                                    <AccordionDetails> 
                              <Card>
                                <CardHeader color="success">
                                  <h4>6. Loading Lisas</h4>
                                </CardHeader>
                                <CardBody>
                                  <GridContainer>
                                    <GridItem xs={12} sm={12} md={6}> 
                                        <p>Two fishermen own two boats, named "Lisa 1" and "Lisa 2". Each boat can hold a maximum cargo of 300kg.</p>
                                        <p>The fishermen are given barrels filled with fish to transport. On each barrel is a number that shows how heavy the barrel is in kilograms.</p>
                                        You must make sure that neither boat is overloaded.
                                        <p>Divide the barrels into two boats so that the maximum possible load of fish is carried</p>
                                        <img alt='bebimage91' className="card-img-top" src={baseUrl+'assets/images/bebimg91.PNG'} />
                                        <h5> 
                                          With the information given above, Answer the questions in the right hand side and below:</h5>
                                          <br />                                               
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={6}>
                                      <h5>Q6.1. Select barrels with total load closest to 300 and less than 300.
                                               Add numbers to calculate load:</h5>
                                          {MCQAnswers('2x2', 18,{que18},
                                            <img alt='bebimage92' className="card-img-top" width="60" height="150" src={baseUrl+'assets/images/bebimg92.PNG'} />
                                            ,<img alt='bebimage93' className="card-img-top" width="60" height="150" src={baseUrl+'assets/images/bebimg93.PNG'} />
                                            ,<img alt='bebimage94' className="card-img-top" width="60" height="150" src={baseUrl+'assets/images/bebimg94.PNG'} />
                                            ,<img alt='bebimage95' className="card-img-top" width="60" height="150" src={baseUrl+'assets/images/bebimg95.PNG'} />
                                            )}  
                                    </GridItem> 
                                    <GridItem xs={12} sm={12} md={12}>
                                      <h5>Q6.2. Divide the barrels into two boats so that maximum possible load of fish is carried:</h5>
                                        {MCQAnswers('2x2', 19,{que19},
                                              <img alt='bebimage96' className="card-img-top" width="60" height="150" src={baseUrl+'assets/images/bebimg96.PNG'} />
                                            ,<img alt='bebimage97' className="card-img-top" width="60" height="150" src={baseUrl+'assets/images/bebimg97.PNG'} />
                                            ,<img alt='bebimage98' className="card-img-top" width="60" height="150" src={baseUrl+'assets/images/bebimg98.PNG'} />
                                            ,'None of the above'
                                            )}
                                    </GridItem>
                                  </GridContainer>
                                </CardBody>
                              </Card>
                            </AccordionDetails>
                          </Accordion>
{/*............................................... Question7 .....................................*/}
                              
                              <Accordion expanded={expanded1 === 'panel27'} onChange={handleAccordionChange1('panel27')}>
                                      <AccordionSummary
                                          expandIcon={<ExpandMoreIcon />}
                                          aria-controls="panel1bh-content"
                                          id="panel1bh-header"
                                        >
                                          <Typography className={classes.heading}>7. Magic potions </Typography>
                                      </AccordionSummary>
                                    <AccordionDetails> 
                              <Card>
                                <CardHeader color="success">
                                  <h4>7. Magic potions</h4>
                                </CardHeader>
                                <CardBody>
                                  <GridContainer>
                                    <GridItem xs={12} sm={12} md={6}>   
                                        <img alt='bebimage99' className="card-img-top" src={baseUrl+'assets/images/bebimg99.PNG'} />
                                        <h5> 
                                          With the information about the experiment given above, Answer the questions in the right hand side and below:</h5>
                                         
                                          <br />

                                       

                                         
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={6}>
                                         <GridContainer>
                                              <GridItem xs={12} sm={12} md={8}>
                                                  <h5>Q7.1. Identify the effect on beaver in exp1-? Select the correct option</h5>      
                                              </GridItem>
                                              <GridItem xs={12} sm={12} md={4}>
                                                  <img alt='bebimage102' className="card-img-top" width="60" height="150" src={baseUrl+'assets/images/bebimg102.PNG'} />
                                              </GridItem>
                                          </GridContainer>
                                            {MCQAnswers('2x2', 20,{que20},'long ear, long teeth, white nose',
                                            'long ear, long teeth',
                                            'long ear, long teeth, white eyes',
                                            'None of the  above'
                                            )}
                                          
                     
                                    </GridItem> 
                                    <GridItem xs={12} sm={12} md={12}>
                                        <GridContainer>
                                              <GridItem xs={12} sm={12} md={6}>
                                                  <h5>Q7.2. Identify the common effect and beaker between exp1-exp2</h5>      
                                              </GridItem>
                                              <GridItem xs={12} sm={12} md={4}>
                                                  <img alt='bebimage100' className="card-img-top" width="60" height="150" src={baseUrl+'assets/images/bebimg100.PNG'} />
                                              </GridItem>
                                              <GridItem xs={12} sm={12} md={6}>
                                                  <h5>Also find the common effect and beaker between exp2- exp3</h5>      
                                              </GridItem>
                                              <GridItem xs={12} sm={12} md={4}>
                                                  <img alt='bebimage101' className="card-img-top" width="60" height="150" src={baseUrl+'assets/images/bebimg101.PNG'} />
                                              </GridItem>
                                          </GridContainer>
                                            {MCQAnswers('row', 21,{que21},
                                              'Beaker, Common effect between (exp1-exp2)-->Beaker A, long ear and between (exp2-exp3)-->Beaker D,long teeth',
                                              'Beaker, Common effect between (exp1-exp2)-->Beaker A, long ear and between (exp2-exp3)-->Beaker D, nothing',
                                              'Beaker, Common effect between (exp1-exp2)-->Beaker A, long teeth and between (exp2-exp3)--> Beaker D, long ear',
                                              'None of the  above'
                                              )}
                                       <h5>Q7.3. Which beaker contains pure water?</h5>      
                                          {MCQAnswers('row', 22,{que22},
                                                  'E',
                                                  'D',
                                                  'C',
                                                  'None of the  above'
                                                  )}
                                    </GridItem>

                                  </GridContainer>
                                </CardBody>
                              </Card>
                              </AccordionDetails>
                              </Accordion>
{/*............................................... Question8 .....................................*/}
                              
                              <Accordion expanded={expanded1 === 'panel28'} onChange={handleAccordionChange1('panel28')}>
                                      <AccordionSummary
                                          expandIcon={<ExpandMoreIcon />}
                                          aria-controls="panel1bh-content"
                                          id="panel1bh-header"
                                        >
                                          <Typography className={classes.heading}>8. Bus stop </Typography>
                                      </AccordionSummary>
                                    <AccordionDetails> 
                              <Card>
                                <CardHeader color="success">
                                  <h4>8. Bus stop</h4>
                                </CardHeader>
                                <CardBody>
                                  <GridContainer>
                                    <GridItem xs={12} sm={12} md={6}>   
                                        
                                        <img alt='bebimage103' className="card-img-top" src={baseUrl+'assets/images/bebimg103.PNG'} />
                                           <h5> 
                                              With the information given above, Answer the questions in the right hand side and below to identify the location for bus stop:
                                          </h5>
                                          <br />
                                         
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={6}> 
                                      <h5>Q8.1. Find the distance from beaver1, beaver2, beaver3, beaver4, beaver5 to bus stop. Calculate the total distance between beaver’s lodges and bus stop:</h5>
                                          <img alt='bebimage104' className="card-img-top" src={baseUrl+'assets/images/bebimg104.PNG'} />
                                        {MCQAnswers('2x2', 23,{que23},'120','130','90','100' )}       
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={12}> 
                                             
                                      <h5>Q8.2. Select the best place for the bus stop (Marked with black dot):</h5>
                                            Select among below options:
                                            {MCQAnswers('2x2', 24,{que24},
                                              <img alt='bebimage105' className="card-img-top" width="60" height="150" src={baseUrl+'assets/images/bebimg105.PNG'} />,
                                              <img alt='bebimage106' className="card-img-top" width="60" height="150" src={baseUrl+'assets/images/bebimg106.PNG'} />,
                                              <img alt='bebimage107' className="card-img-top" width="60" height="150" src={baseUrl+'assets/images/bebimg107.PNG'} />,
                                              <img alt='bebimage108' className="card-img-top" width="60" height="150" src={baseUrl+'assets/images/bebimg108.PNG'} />

                                                )}
                                    </GridItem>  
                                  </GridContainer>
                                </CardBody>
                              </Card>
                              </AccordionDetails>
                            </Accordion> 
{/*............................................... Question9 .....................................*/}
                              
                              <Accordion expanded={expanded1 === 'panel29'} onChange={handleAccordionChange1('panel29')}>
                                      <AccordionSummary
                                          expandIcon={<ExpandMoreIcon />}
                                          aria-controls="panel1bh-content"
                                          id="panel1bh-header"
                                        >
                                          <Typography className={classes.heading}>9. Mobile phones </Typography>
                                      </AccordionSummary>
                                    <AccordionDetails> 
                              <Card>
                                <CardHeader color="success">
                                <h4>9. Mobile phones</h4>
                                </CardHeader>
                                <CardBody>
                                  <GridContainer>
                                    <GridItem xs={12} sm={12} md={6}>   
                                        
                                        <p>The beaver family have three mobile phones but none of the batteries have any charge.</p>
                                        <p>It takes 1 hour to fully charge a mobile phone but this does not need to be done all in one go.</p>
                                        <h5> The beaver family only have two mobile phone chargers in the house. Answer the questions below related to the above problem:</h5>   
                                          <br />
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={6}>
                                      <img alt='bebimage109' className="card-img-top" src={baseUrl+'assets/images/bebimg109.PNG'} />                                         
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={12}>
                                        <h5>Q9.1. Suppose the family had 2 mobile phones with no charge in batteries. Now if the family had 2 chargers, select a way that may provide the shortest time needed to fully recharge the phones.</h5>
                                        {MCQAnswers('row', 25,{que25},
                                        'charging mobile1 for 1 hour and then charging mobile2 for 1 hour=total time 2 hours'
                                        ,'charging mobile1 for ½ hour and then charging mobile2 for ½ hour and charging mobile1 for 1/2hr and finally charging mobile2 for ½ hour=total time 2 hours',
                                        'charging mobile1 and mobile2 at the same time for 1 hour=total time 1 hour'
                                        ,'None of the above' )}
                                        <h5>Q9.2. Consider the question 9, the family has 3 mobile phones with no charge in batteries. Now if the family had 2 chargers, select a way that may provide the shortest time needed to fully recharge the phones:</h5>
                                              {MCQAnswers('row', 26,{que26},
                                              'charging mobile1 and mobile2 for 1 hour and then charging mobile3 for 1 hour'
                                              ,'charging mobile1 and mobile2 for ½ hour and then charging mobile2 and mobile3 for ½ hour and finally charging mobile1 and mobile3 for 1/2hr',
                                              'charging mobile1 and mobile2 for 1/2 hour and then charging mobile3 for 1 hour and then charging mobile1 and mobile2 for 1/2 hour'
                                              ,'None of the above' )} 
                                        <h5>Q9.3. What is the shortest time they need to fully recharge the three phones?</h5>
                                        {MCQAnswers('row', 27,{que27},'3 hours','2 hours','1 hour and a half','1 hour' )} 
                                          
                                    </GridItem> 
                                  </GridContainer>
                                </CardBody>
                              </Card>
                            </AccordionDetails>
                            </Accordion>
{/*............................................... Question10 .....................................*/}
                              
                              <Accordion expanded={expanded1 === 'panel30'} onChange={handleAccordionChange1('panel30')}>
                                      <AccordionSummary
                                          expandIcon={<ExpandMoreIcon />}
                                          aria-controls="panel1bh-content"
                                          id="panel1bh-header"
                                        >
                                          <Typography className={classes.heading}>10. Beavers on the run </Typography>
                                      </AccordionSummary>
                                    <AccordionDetails> 
                              <Card>
                                <CardHeader color="success">
                                  <h4>10. Beavers on the run </h4>
                                </CardHeader>
                                <CardBody>
                                  <GridContainer>
                                    <GridItem xs={12} sm={12} md={12}>   
                                        
                                        <img alt='beb110' className="card-img-top" src={baseUrl+'assets/images/beb110.PNG'} />
                                        <img alt='bebimg111' className="card-img-top" src={baseUrl+'assets/images/bebimg111.PNG'} />
                                        <h5> 
                                          With the information given above, Answer the questions below:</h5>
                                          <br />
                                        
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={6}>
                                          <GridContainer>
                                              <GridItem xs={12} sm={12} md={8}>
                                                  <h5>Q10.1. Can you find the order of beaver in the hole from top to bottom when the beavers pass through first hole? </h5>
                                              </GridItem>
                                              <GridItem xs={12} sm={12} md={4}>
                                                  <img alt='bebimage112' className="card-img-top" width="60" height="150" src={baseUrl+'assets/images/bebimg112.PNG'} />
                                              </GridItem>
                                          </GridContainer>
                                          
                                        {MCQAnswers('row', 28,{que28},'4321','1234','4567','None of the above' )}                                             
                                    </GridItem> 
                                    <GridItem xs={12} sm={12} md={12}>
                                    <h5>Q10.2. Select the algorithm to find the order of beavers after passing through holes? </h5>
                                          
                                          {MCQAnswers('2x2', 29,{que29},
                                              <img alt='bebimage113' className="card-img-top" src={baseUrl+'assets/images/bebimg113.PNG'} />
                                              ,<img alt='bebimage114' className="card-img-top" src={baseUrl+'assets/images/bebimg114.PNG'} />
                                              ,<img alt='bebimage115' className="card-img-top" src={baseUrl+'assets/images/bebimg115.PNG'} />
                                              ,'None of the above'
                                              )} 
                                    </GridItem> 
                                    <GridItem xs={12} sm={12} md={12}>

                                        <h5>Q10.3. Select the order of beavers after they passed the third hole:</h5>
                                              {MCQAnswers('row', 30,{que30},
                                              '4756123',
                                              '6754321',
                                              '2165347',
                                              '5761432' )} 
                                          
                                    </GridItem>
                                  </GridContainer>
                                </CardBody>
                              </Card>
                              </AccordionDetails>
                              </Accordion>
{/*............................................... Question11 .....................................*/}
                              
                              <Accordion expanded={expanded1 === 'panel31'} onChange={handleAccordionChange1('panel31')}>
                                      <AccordionSummary
                                          expandIcon={<ExpandMoreIcon />}
                                          aria-controls="panel1bh-content"
                                          id="panel1bh-header"
                                        >
                                          <Typography className={classes.heading}>11. Levenshtein Distance </Typography>
                                      </AccordionSummary>
                                    <AccordionDetails> 
                              <Card>
                                <CardHeader color="success">
                                  <h4>11. Levenshtein Distance</h4>
                                </CardHeader>
                                <CardBody>
                                  <GridContainer>
                                    <GridItem xs={12} sm={12} md={6}>   
                                    <p>We define a basic operation as one of the following:</p>
                                      <p>• insert one character into a word,</p>
                                      <p>• remove one character from a word,</p>
                                      <p>• replace one character with another.</p>
                                      <p>We define the distance between two words as the minimum number of basic operations which
                                      allows us to change the first word into the second.</p>
                                      <p>For example, the distance between kitten and sitting is equal to 3. The basic operations
                                      necessary are:</p>
                                      <p>1. kitten → sitten (change k to s),</p>
                                      <p>2. sitten → sittin (change i to e),</p>
                                          3. sittin → sitting (insert g at the end).
                                        <h5> 
                                          With the information given above, Answer the question in the right hand side and below:</h5>
                                          <br />
                                          
                                 
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={6}>
                                          <h5>Q11.1. Identify the common characters between length and french? </h5>
                                            {MCQAnswers('row', 31,{que31},
                                            'only ‘e’ and ‘h’','only ‘en’','‘en’ and ‘h’','None of the above' )} 
                                            
                          
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={12}>
                                      <h5>Q11.2. Select basic operations to change from ‘length’ to ‘french’ in minimum number of operations? :</h5>
                                              {MCQAnswers('2x2', 32,{que32},
                                              <img alt='bebimage116' className="card-img-top" src={baseUrl+'assets/images/bebimg116.PNG'} />
                                              ,<img alt='bebimage117' className="card-img-top" src={baseUrl+'assets/images/bebimg117.PNG'} />
                                              ,<img alt='bebimage118' className="card-img-top" src={baseUrl+'assets/images/bebimg118.PNG'} />
                                              ,'None of the above'
                                              )} 
                                      <h5>Q11.3. What is the minimum distance between length and french?  </h5>
                                            {MCQAnswers('row', 33,{que33},
                                            '3','4','5','None of the above' )} 
                                    </GridItem> 
                                  </GridContainer>
                                </CardBody>
                              </Card>
                              </AccordionDetails>
                              </Accordion>
{/*............................................... Question12 .....................................*/}
                              
                              <Accordion expanded={expanded1 === 'panel32'} onChange={handleAccordionChange1('panel32')}>
                                      <AccordionSummary
                                          expandIcon={<ExpandMoreIcon />}
                                          aria-controls="panel1bh-content"
                                          id="panel1bh-header"
                                        >
                                          <Typography className={classes.heading}>12. Candy maze </Typography>
                                      </AccordionSummary>
                                    <AccordionDetails> 
                              <Card>
                                <CardHeader color="success">
                                  <h4>12. Candy maze</h4>
                                </CardHeader>
                                <CardBody>
                                  <GridContainer>
                                    <GridItem xs={12} sm={12} md={12}>
                                          <GridContainer>
                                              <GridItem xs={12} sm={12} md={8}>
                                                  <p>A robot is programmed to collect as many sweets as possible. It does this while walking
                                                  through cells.</p> 
                                                  <p>Each cell in the grid on the right has either 0, 1, 2 or 3 sweets.
                                                  The robot begins in the bottom-left and ends in the top-right. The robot can only move to the
                                                  right or upwards. </p>
                                                  <h5> With the information given above, Answer the question in the right hand side and below:</h5>

                                              </GridItem>
                                              <GridItem xs={12} sm={12} md={4}>
                                                  <img alt='bebimage119' className="card-img-top" width="60" height="150" src={baseUrl+'assets/images/bebimg119.PNG'} />
                                              </GridItem>
                                          </GridContainer>      
                                        
                                        
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={12}>
                                      <GridContainer>
                                          <GridItem xs={12} sm={12} md={6}>
                                              <h5>Q12.1. Given a path of robot from bottom end to top right in right hand side picture: </h5>
                                              <h5>Count the number of sweet collected. Select the options below:</h5> 
                                          </GridItem>
                                          <GridItem xs={12} sm={12} md={4}>
                                              <img alt='bebimage120' className="card-img-top" width="60" height="150" src={baseUrl+'assets/images/bebimg120.PNG'} />
                                          </GridItem>
                                      </GridContainer>
                                              
                                          {MCQAnswers('row', 34,{que34},'12','13','14','15' )}
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={12}>
                                          <h5>Q12.2. Select the path of robot to collect maximum possible sweets from the grid:</h5>
                                              {MCQAnswers('row', 35,{que35},
                                              <img alt='bebimage121' className="card-img-top" src={baseUrl+'assets/images/bebimg121.PNG'} />
                                              ,<img alt='bebimage120' className="card-img-top" src={baseUrl+'assets/images/bebimg120.PNG'} />
                                              ,<img alt='bebimage122' className="card-img-top" src={baseUrl+'assets/images/bebimg122.PNG'} />
                                              ,'None of the above'
                                              )}
                                          
                                          <h5>Q12.3. How many maximum sweets will the robot collect in the grid: </h5>
                                              {MCQAnswers('row', 36,{que36},'12','13','14','15' )}
                                    </GridItem> 
                                  </GridContainer>
                                  
                                </CardBody>
                            </Card>
                            </AccordionDetails>
                            </Accordion>
                            </GridItem>
                     
                        </GridContainer>
                        
                        </CardBody>
                    </Card>      

            <Card>
                <CardHeader color="success">
                    <h4 style={classes1.cardTitleWhite}> SUS IBM questionnaire and Feedback</h4>
                </CardHeader>
                <CardBody>
                <GridContainer>
                <Accordion expanded={expanded1 === 'panel91'} onChange={handleAccordionChange1('panel91')}>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1bh-content"
                            id="panel1bh-header"
                            >
                            <Typography className={classes.heading}>SUS IBM Questionnaire </Typography>
                        </AccordionSummary>
                        <AccordionDetails> 
                    <GridItem xs={12} sm={6} md={12}>
                        <Card style={{    border: '2px solid grey'}}>
                            <CardHeader color="info">
                                <h4 style={classes1.cardTitleWhite}>SUS IBM Questionnaire</h4>
                            </CardHeader>
                            <CardBody>
                            <GridContainer>
                            <GridItem xs={12} sm={12} md={8}>   
                                            <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label=""
                                                value="1.	I think that I would like to use this system frequently."
                                                //disabled={true}
                                                //onChange={handlePatternChange}
                                                select
                                                variant="standard"
                                                //helperText="select"
                                                //style = {{width: 30}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {[{label:'1.	I think that I would like to use this system frequently.',value:'1.	I think that I would like to use this system frequently.'}].map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                            </Field>
                                    </GridItem>                                    
                                    <GridItem xs={12} sm={12} md={4}>
                                            <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label="Number"
                                                value={que37}
                                                onChange={handleQue37Change}
                                                select
                                                variant="standard"
                                                helperText="select"
                                                //style = {{width: 60}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {answerList.map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field>
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={8}>   
                                          <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label=""
                                                value="2.	I found the system unnecessarily complex."
                                                //disabled={true}
                                                //onChange={handlePatternChange}
                                                select
                                                variant="standard"
                                                //helperText="select"
                                                //style = {{width: 30}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {[{label:'2.	I found the system unnecessarily complex.',value:'2.	I found the system unnecessarily complex.'}].map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                            </Field>
                                    </GridItem>                                    
                                    <GridItem xs={12} sm={12} md={4}>
                                            <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label="Number"
                                                value={que38}
                                                onChange={handleQue38Change}
                                                select
                                                variant="standard"
                                                helperText="select"
                                                //style = {{width: 60}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {answerList.map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field>
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={8}>   
                                            <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label=""
                                                value="3.	I thought the system was easy to use."
                                                //disabled={true}
                                                //onChange={handlePatternChange}
                                                select
                                                variant="standard"
                                                //helperText="select"
                                                //style = {{width: 30}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {[{label:'3.	I thought the system was easy to use.',value:'3.	I thought the system was easy to use.'}].map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                            </Field>
                                    </GridItem>                                    
                                    <GridItem xs={12} sm={12} md={4}>
                                            <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label="Number"
                                                value={que39}
                                                onChange={handleQue39Change}
                                                select
                                                variant="standard"
                                                helperText="select"
                                                //style = {{width: 60}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {answerList.map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field>
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={8}>   
                                            <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label=""
                                                value="4.	I think that I would need the support of a technical person to be able to use this system."
                                                //disabled={true}
                                                //onChange={handlePatternChange}
                                                select
                                                variant="standard"
                                                //helperText="select"
                                                //style = {{width: 30}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {[{label:'4.	I think that I would need the support of a technical person to be able to use this system.',value:'4.	I think that I would need the support of a technical person to be able to use this system.'}].map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                            </Field>
                                    </GridItem>                                    
                                    <GridItem xs={12} sm={12} md={4}>
                                            <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label="Number"
                                                value={que40}
                                                onChange={handleQue40Change}
                                                select
                                                variant="standard"
                                                helperText="select"
                                                //style = {{width: 60}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {answerList.map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field>
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={8}>   
                                            <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label=""
                                                value="5.	I found the various functions in this system were well integrated."
                                                //disabled={true}
                                                //onChange={handlePatternChange}
                                                select
                                                variant="standard"
                                                //helperText="select"
                                                //style = {{width: 30}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {[{label:'5.	I found the various functions in this system were well integrated.',value:'5.	I found the various functions in this system were well integrated.'}].map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                            </Field>
                                    </GridItem>                                    
                                    <GridItem xs={12} sm={12} md={4}>
                                            <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label="Number"
                                                value={que41}
                                                onChange={handleQue41Change}
                                                select
                                                variant="standard"
                                                helperText="select"
                                                //style = {{width: 60}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {answerList.map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field>
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={8}>   
                                            <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label=""
                                                value="6.	I thought there was too much inconsistency in this system."
                                                //disabled={true}
                                                //onChange={handlePatternChange}
                                                select
                                                variant="standard"
                                                //helperText="select"
                                                //style = {{width: 30}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {[{label:'6.	I thought there was too much inconsistency in this system.',value:'6.	I thought there was too much inconsistency in this system.'}].map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                            </Field>
                                    </GridItem>                                    
                                    <GridItem xs={12} sm={12} md={4}>
                                            <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label="Number"
                                                value={que42}
                                                onChange={handleQue42Change}
                                                select
                                                variant="standard"
                                                helperText="select"
                                                //style = {{width: 60}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {answerList.map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field>
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={8}>   
                                            <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label=""
                                                value="7.	I would imagine that most people would learn to use this system very quickly."
                                                //disabled={true}
                                                //onChange={handlePatternChange}
                                                select
                                                variant="standard"
                                                //helperText="select"
                                                //style = {{width: 30}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {[{label:'7.	I would imagine that most people would learn to use this system very quickly.',value:'7.	I would imagine that most people would learn to use this system very quickly.'}].map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                            </Field>
                                    </GridItem>                                    
                                    <GridItem xs={12} sm={12} md={4}>
                                            <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label="Number"
                                                value={que43}
                                                onChange={handleQue43Change}
                                                select
                                                variant="standard"
                                                helperText="select"
                                                //style = {{width: 60}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {answerList.map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field>
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={8}>   
                                            <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label=""
                                                value="8.	I found the system very cumbersome to use."
                                                //disabled={true}
                                                //onChange={handlePatternChange}
                                                select
                                                variant="standard"
                                                //helperText="select"
                                                //style = {{width: 30}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {[{label:'8.	I found the system very cumbersome to use.',value:'8.	I found the system very cumbersome to use.'}].map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                            </Field>
                                    </GridItem>                                    
                                    <GridItem xs={12} sm={12} md={4}>
                                            <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label="Number"
                                                value={que44}
                                                onChange={handleQue44Change}
                                                select
                                                variant="standard"
                                                helperText="select"
                                                //style = {{width: 60}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {answerList.map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field>
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={8}>   
                                            <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label=""
                                                value="9.	I felt very confident using the system."
                                                //disabled={true}
                                                //onChange={handlePatternChange}
                                                select
                                                variant="standard"
                                                //helperText="select"
                                                //style = {{width: 30}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {[{label:'9.	I felt very confident using the system.',value:'9.	I felt very confident using the system.'}].map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                            </Field>
                                    </GridItem>                                    
                                    <GridItem xs={12} sm={12} md={4}>
                                            <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label="Number"
                                                value={que45}
                                                onChange={handleQue45Change}
                                                select
                                                variant="standard"
                                                helperText="select"
                                                //style = {{width: 60}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {answerList.map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field>
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={8}>   
                                            <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label=""
                                                value="10.	I needed to learn a lot of things before I could get going with this system."
                                                //disabled={true}
                                                //onChange={handlePatternChange}
                                                select
                                                variant="standard"
                                                //helperText="select"
                                                //style = {{width: 30}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {[{label:'10.	I needed to learn a lot of things before I could get going with this system.',value:'10.	I needed to learn a lot of things before I could get going with this system.'}].map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                            </Field>
                                    </GridItem>                                    
                                    <GridItem xs={12} sm={12} md={4}>
                                            <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label="Number"
                                                value={que46}
                                                onChange={handleQue46Change}
                                                select
                                                variant="standard"
                                                helperText="select"
                                                //style = {{width: 60}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {answerList.map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field>
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={12}>
                            <Card>
                              <CardHeader color="success">
                              <h5 style={classes.cardTitleWhite}> Feedback related to the Platform. Read each questions and answer accordingly</h5>
                              </CardHeader>
                                <b>{error!=''?'error: '+error:''}</b>
                              <CardBody>
                              <GridContainer>
                              <GridItem xs={12} sm={12} md={6}>
                                    <h4 align='center'>Feedback questions</h4>   
                                  </GridItem>
                                  <GridItem xs={12} sm={12} md={6}> 
                                      <h5>Answer </h5>
                                  </GridItem>
                                    <GridItem xs={12} sm={12} md={12}>   
                                            
                                            <h5>1.	Do you have any previous experience of using Algorithmic development app?
                                   
                                              <Field
                                                  component={TextField}
                                                  type="text"
                                                  //label="Enter name"
                                                  name="name"
                                                  value={que47}
                                                  placeholder='Enter answer'
                                                  onChange={handleQue47Change} 
                                                />
                                                </h5>
                                            
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={12}>   
                                          
                                            <h5>2. How much would you rate the CT-Onlinq app?(1=very bad, 2=bad, 3=normal, 4=good, 5=very good)
                                   
                                              <Field
                                                  component={TextField}
                                                  type="text"
                                                  //label="Enter name"
                                                  name="name"
                                                  value={que48}
                                                  placeholder='Enter answer'
                                                  onChange={handleQue48Change} 
                                                />
                                                </h5>
                                    </GridItem>
                                                                     
                                    <GridItem xs={12} sm={12} md={12}>
                                      <h5>3. Did you find the CT-Onlinq app useful?
                                              <Field
                                                  component={TextField}
                                                  type="text"
                                                  //label="Enter name"
                                                  name="name"
                                                  value={que49}
                                                  placeholder='Enter answer'
                                                  onChange={handleQue49Change} 
                                                />
                                                </h5>
                                    </GridItem>
                                                                       
                                    <GridItem xs={12} sm={12} md={12}>
                                      <h5> 4. What did you like about the CT-Onlinq app?
                                              <Field
                                                  component={TextField}
                                                  type="text"
                                                  //label="Enter name"
                                                  name="name"
                                                  value={que50}
                                                  placeholder='Enter answer'
                                                  onChange={handleQue50Change} 
                                                />
                                              </h5>
                                    </GridItem>
                                                                       
                                    <GridItem xs={12} sm={12} md={12}>
                                      <h5>  5. What are the difficulties you faced with the functions of CT-Onlinq?
                                              <Field
                                                  component={TextField}
                                                  type="text"
                                                  //label="Enter name"
                                                  name="name"
                                                  value={que51}
                                                  placeholder='Enter answer'
                                                  onChange={handleQue51Change} 
                                                />
                                                </h5>
                                    </GridItem>
                                                                      
                                    <GridItem xs={12} sm={12} md={12}>
                                        <h5> 6.	What can we do to improve the User Interface of CT-Onlinq?
                                              <Field
                                                  component={TextField}
                                                  type="text"
                                                  //label="Enter name"
                                                  name="name"
                                                  value={que52}
                                                  placeholder='Enter answer'
                                                  onChange={handleQue52Change} 
                                                />
                                              </h5>
                                    </GridItem>
                                                                        
                                    <GridItem xs={12} sm={12} md={12}>
                                      <h5> 7.	Any suggestions about the overall App that needs to be improved?
                                                <Field
                                                  component={TextField}
                                                  type="text"
                                                  //label="Enter name"
                                                  name="name"
                                                  value={que53}
                                                  placeholder='Enter answer'
                                                  onChange={handleQue53Change} 
                                                />
                                            </h5>
                                    </GridItem>
                                                                     
                                    <GridItem xs={12} sm={12} md={12}>
                                          <h5> 8.	What goals or benefits are you seeking through the use of CT-Onlinq?
                                              <Field
                                                  component={TextField}
                                                  type="text"
                                                  //label="Enter name"
                                                  name="name"
                                                  value={que54}
                                                  placeholder='Enter answer'
                                                  onChange={handleQue54Change} 
                                                />
                                            </h5>
                                    </GridItem>
                                                                       
                                    <GridItem xs={12} sm={12} md={12}>
                                            <h5> 9.	Would you like to motivate your friends to use CT-Onlinq? If yes/no, why?
                                              
                                              <Field
                                                  component={TextField}
                                                  type="text"
                                                  //label="Enter name"
                                                  name="name"
                                                  value={que55}
                                                  placeholder='Enter answer'
                                                  onChange={handleQue55Change} 
                                                />
                                            </h5>
                                    </GridItem>
                                                                       
                                    <GridItem xs={12} sm={12} md={12}>
                                          <h5> 10.	Do you have anything else you would like to share about CT-Onlinq?
                                              <Field
                                                  component={TextField}
                                                  type="text"
                                                  //label="Enter name"
                                                  name="name"
                                                  value={que56}
                                                  placeholder='Enter answer'
                                                  onChange={handleQue56Change} 
                                                />
                                              </h5>
                                    </GridItem>
   
                               
                                
                              </GridContainer>
                              </CardBody>
                            </Card>
                            </GridItem>
                            </GridContainer>
                            </CardBody>
                        </Card>
                    </GridItem>
                    </AccordionDetails>
                    </Accordion>
                    
                </GridContainer>
                
                </CardBody>
            </Card>
            </Form>
          </LocalizationProvider>
          )}
          </Formik>
        </GridContainer>:<p>This is some problem / Please Login again</p> }

      {/* <div className="container">
          <div className="px-0 col-lg-8 col-md-10 col-sm-12 mx-auto text-center">
              <p className="font-size-lg text-black-100">
                    Inactive classes
              </p>
          </div>
      </div> */}


    </div>:<GridContainer spacing={3}>
        <GridItem xs={12} sm={12} md={4}>
        </GridItem>
        <GridItem xs={12} sm={12} md={4}>
          <Skeleton variant="text" /> 
          <Skeleton variant="text" /> 
        </GridItem>
        <GridItem xs={12} sm={12} md={4}>
        </GridItem>
        <GridItem xs={12} sm={12} md={4}>
          <Box sx={{ width: 420, marginRight: 2, my: 5, padding: 2 }}>
            <Skeleton animation="wave" variant="rectangular" width={420} height={300} />    
          </Box>
          </GridItem>
          <GridItem xs={12} sm={12} md={4}>
          <Box sx={{ width: 420, marginRight: 2, my: 5 }}>
            <Skeleton animation="wave" variant="rectangular" width={420} height={300} />    
          </Box> 
          </GridItem>
          <GridItem xs={12} sm={12} md={4}>
          <Box sx={{ width: 420, marginRight: 2, my: 5 }}>
            <Skeleton variant="circular" width={420} height={300} />    
          </Box> 
        </GridItem>
        <GridItem xs={12} sm={12} md={4}>
        </GridItem>
        <GridItem xs={12} sm={12} md={4}>
          <Skeleton variant="text" /> 
        </GridItem>  
      </GridContainer>
  );
}
